<div class="fill-height py-2 d-flex">

  <div *ngIf="isLoading" class="d-flex h-100 align-items-center justify-content-center">
    <mat-spinner class="zx-small-icon-size"></mat-spinner>
  </div>

  <div *ngIf="!isLoading" class="w-100 flex-grow-1 d-flex flex-column">

    <article class="d-flex align-items-center gap-2 w-100 p-3 c-pointer">
      <app-navigation-from-printer-manigment class="d-flex flex-grow-1"></app-navigation-from-printer-manigment>
    </article>

    <mat-tab-group class="w-100 d-flex flex-grow-1 flex-column custom-tab-group"
      (selectedTabChange)="onTabChange($event)" [dir]="isRTL ? 'rtl' : 'ltr'">

















































      <!-- ===== ===== ===== ===== ===== ===== printer ===== ===== ===== ===== ===== ===== -->
      <mat-tab [disabled]="isLoadingTabChange" class="w-100 d-flex flex-grow-1 flex-column" label="print">
        <ng-template mat-tab-label>
          <div class="d-flex flex-column flex-lg-row-reverse align-items-center justify-content-center gap-1 gap-lg-2">
            <b class="zx-text-tiny-tiny zx-text-sm-small">
              {{ 'su-management.printer-management.short' | translate }}
            </b>
            <mat-icon>print</mat-icon>
          </div>
        </ng-template>
        <!-- content -->
        <div *ngIf="subPage === 'printer' || subPage === 'print'" class="w-100 d-flex h-100 flex-column">

          <!-- loading -->
          <div *ngIf="isLoadingPrinter"
            class="w-100 d-flex flex-grow-1 flex-column align-items-center justify-content-center p-3 px-lg-5">
            <mat-spinner class="zx-medium-icon-size zx-medium-big-icon-size-lg"></mat-spinner>
          </div>

          <!-- content -->
          <div *ngIf="!isLoadingPrinter" class="w-100 d-flex flex-grow-1 flex-column p-3 px-lg-5">

            <!-- --------------- title --------------- -->
            <div class="w-100 d-flex justify-content-center zx-border-bottom-green-bold mb-4 pb-2 px-3 px-lg-5">
              <h6 class="fw-bold zx-text-medium zx-text-sm-big" [class.text-green]="!isDarkMode">
                {{ 'su-management.printer-management' | translate }}
              </h6>
            </div>
            <!-- // --------------- title --------------- -->

            <!-- anydesk branch.branches.printers[0].anydesk -->
            <div class="w-100 d-flex justify-content-end zx-move-up-anydesk">
              <a [href]="getAnydesk()" target="_blank" class="anydesk-button">
                <img src="assets/images/anydesk-icon.png" alt="Anydesk Icon"
                  class="svg zx-small-icon-size zx-small-plus-icon-size-lg p-lg-1">
              </a>
            </div>

            <!-- --------------- printer status line --------------- -->
            <div class="d-flex row">
              <!-- printer status -->
              <div class="col-4 col-md-2 d-flex flex-column gap-lg-1" [class.text-red]="(getPrinterStatus() !== 'ready' &&
              getPrinterStatus() !== 'Available' &&
              getPrinterStatus() !== 'sleep' &&
              getPrinterStatus() !== 'processing' &&
              getPrinterStatus() !== 'Busy' &&
              getPrinterStatus() !== 'idle')">
                <b class="zx-text-tiny pb-2 opacity-75">
                  {{ 'su-management.printer-status' | translate }}
                </b>
                <span class="zx-text-small zx-text-sm-medium" [class.text-green]="(getPrinterStatus() === 'ready' ||
                getPrinterStatus() === 'Available' ||
                getPrinterStatus() === 'sleep' ||
                getPrinterStatus() === 'processing' ||
                getPrinterStatus() === 'Busy' ||
                getPrinterStatus() === 'idle')">
                  {{ 'su-management.printer-status.' + getPrinterStatus() | translate }}
                </span>
                <span class="zx-text-tiny opacity-50">
                  {{ getPrinterStatus() }}
                </span>
              </div>
              <!-- printer errors -->
              <div class="col-4 col-md-2 d-flex flex-column gap-lg-1">
                <b class="zx-text-tiny pb-2 opacity-75">
                  {{ 'su-management.printer-errors' | translate }}
                </b>
                <div *ngIf="getPrinterErrorsArray() && getPrinterErrorsArray().length > 0"
                  class="w-100 d-flex flex-column gap-lg-1">
                  <span *ngFor="let error of getPrinterErrorsArray()" class="zx-text-small zx-text-sm-medium">
                    {{ error }}
                  </span>
                </div>
                <span class="zx-text-small zx-text-sm-medium" *ngIf="getPrinterErrorsArray().length === 0">
                  {{ 'su-management.printer-no-errors' | translate }}
                </span>
              </div>
              <!-- last Online At -->
              <div class="col-4 col-md-2 d-flex flex-column gap-lg-1">
                <b class="zx-text-tiny pb-2 opacity-75">
                  {{ 'su-management.last-online-at' | translate }}
                </b>
                <span class="zx-text-small zx-text-sm-medium" [class.text-red-bold]="!getIsLastOnlineIsVeryUpdated()">
                  {{ getLastOnlineAtTime() }}
                </span>
                <span class="zx-text-tiny" [class.text-red-bold]="!getIsLastOnlineIsVeryUpdated()">
                  {{ getLastOnlineAtDate() }}
                </span>
              </div>
              <!-- prinscreen -->
              <div class="col-8 mt-3 c-pointer" [class.zx-screen-height-small]="!isBigSizeScreen"
                [class.mt-md-0]="!isBigSizeScreen" [class.zx-screen-height-big]="isBigSizeScreen"
                [class.col-12]="isBigSizeScreen" [class.col-md-4]="!isBigSizeScreen" (click)="toggleScreenImageSize()">
                <img [src]="screenImageUrl" alt="Screen Image"
                  class="w-100 h-100 object-fit-contain rounded-2 shadow-85">
              </div>
              <!-- printingCode -->
              <div *ngIf="printingService === 'express' &&
              !branch.error && !branch.queue?.printerQueue?.length
              && isVeryUpdated()" class="col-4 col-md-2 d-flex flex-column gap-lg-1 mt-3">
                <b class="zx-text-tiny pb-2 opacity-75">
                  {{ 'when-to-print-printing-code' | translate }}
                </b>
                <b class="zx-text-pink zx-text-small zx-text-sm-medium">
                  {{
                  printingCode(
                  branch.unique,
                  branch.properties?.code
                  )
                  }}
                </b>
              </div>
              <!-- printer number -->
              <div class="col-4 col-md-2 d-flex flex-column gap-lg-1 mt-3">
                <b class="zx-text-tiny pb-2 opacity-75">
                  {{ 'by-p-num.printer-num' | translate }}
                </b>
                <span class="zx-text-small zx-text-sm-medium">
                  {{ "#" + branch.unique }}
                </span>
              </div>

            </div>
            <!-- // --------------- printer status line --------------- -->

            <div class="d-flex w-100 zx-border-bottom-gray-v-light-mid my-4"></div>

            <!-- --------------- queue status = title --------------- -->
            <div class="d-flex justify-content-between w-100">
              <b class="zx-text-tiny pb-2 opacity-75">
                {{ 'su-management.queue-status' | translate }}
              </b>
              <div *ngIf="printingService === 'plotter'" (click)="goToPrintingQueue()"
                class="p-1 rounded-2 d-flex justify-content-center c-pointer" mat-ripple
                [matTooltip]="'order-complited.printed.view-que' | translate" [matTooltipPosition]="'below'">
                <img *ngIf="!isDarkMode" src="assets/images/queue-icon.svg" class="svg zx-small-icon-size c-pointer">
                <img *ngIf="isDarkMode" src="assets/images/queue-icon-green.svg"
                  class="svg zx-small-icon-size c-pointer">
              </div>
            </div>
            <!-- // --------------- queue status = title --------------- -->

            <!-- --------------- queue status = empty --------------- -->
            <div *ngIf="!getIsQueueEmpty()" class="w-100 d-flex shadow-85 rounded-2 py-2 mt-2 justify-content-center">
              <span class="zx-text-small zx-text-sm-medium">
                {{ 's-screen.plotter-que.empty-title' | translate }}
              </span>
            </div>
            <!-- // --------------- queue status = empty --------------- -->

            <!-- --------------- queue status = full --------------- -->
            <div *ngIf="getIsQueueEmpty()" class="d-flex row shadow-85 rounded-2 py-2 mt-2">

              <!-- plotter -->
              <!-- amount of orders [plotter] -->
              <div *ngIf="printingService === 'plotter'"
                class="col-4 col-md-3 col-lg-2 d-flex justify-content-center p-0 zx-text-small zx-text-sm-medium">
                <span *ngIf="getQueueLength() === 1">
                  {{ 'my-profile.order-one' | translate }}
                </span>
                <span *ngIf="getQueueLength() > 1">
                  <span>
                    {{ getQueueLength() }}
                  </span>
                  <span>
                    {{ 'my-profile.order-many' | translate }}
                  </span>
                </span>
              </div>
              <!-- // amount of orders [plotter] -->

              <!-- amount of files [plotter] -->
              <div *ngIf="printingService === 'plotter'"
                class="col-4 col-md-3 col-lg-2 d-flex justify-content-center p-0 zx-text-small zx-text-sm-medium">
                <span *ngIf="getQueueAmountOfFiles() === 1">
                  {{ 'printing-table.one-file' | translate }}
                </span>
                <span *ngIf="getQueueAmountOfFiles() > 1">
                  <span>
                    {{ getQueueAmountOfFiles() }}
                  </span>
                  <span>
                    {{ 'printing-table.files' | translate }}
                  </span>
                </span>
              </div>
              <!-- // amount of files [plotter] -->

              <!-- amount of minutes [plotter] -->
              <div *ngIf="printingService === 'plotter'"
                class="col-4 col-md-3 col-lg-2 d-flex justify-content-center p-0 zx-text-small zx-text-sm-medium">
                <span>
                  <span>
                    {{ getQueueAmountOfMinutes() }}
                  </span>
                  <span>
                    {{ 's-screen.minutes' | translate }}
                  </span>
                </span>
              </div>
              <!-- // amount of minutes [plotter] -->

              <!-- express -->
              <!-- username [express] -->
              <div *ngIf="printingService === 'express'"
                class="col-4 col-md-3 col-lg-2 d-flex flex-column gap-lg-1 justify-content-center p-0 px-2 zx-text-small zx-text-sm-medium">
                <b class="zx-text-tiny pb-2 opacity-75">
                  {{ 'su-management.printing-order-of' | translate }}
                </b>
                <span class="zx-text-small zx-text-sm-medium">
                  {{ getQueueCurrentUser() }}
                </span>
              </div>
              <!-- // username [express] -->

              <!-- amount of files [express] -->
              <div *ngIf="printingService === 'express'"
                class="col-4 col-md-3 col-lg-2 d-flex flex-column gap-lg-1 justify-content-center p-0 px-2 zx-text-small zx-text-sm-medium">
                <b class="zx-text-tiny pb-2 opacity-75">
                  {{ 'su-management.order-num-of-files' | translate }}
                </b>
                <span class="zx-text-small zx-text-sm-medium">
                  <span *ngIf="getQueueCurrentOrderAmountOfPages() === 1">
                    {{ 'printing-table.one-file' | translate }}
                  </span>
                  <span *ngIf="getQueueCurrentOrderAmountOfPages() > 1">
                    <span>
                      {{ getQueueCurrentOrderAmountOfPages() }}
                    </span>
                    <span>
                      {{ 'printing-table.files' | translate }}
                    </span>
                  </span>
                </span>
              </div>
              <!-- // amount of files [express] -->

              <!-- amount of pages [express] -->
              <div *ngIf="printingService === 'express'"
                class="col-4 col-md-3 col-lg-2 d-flex flex-column gap-lg-1 justify-content-center p-0 px-2 zx-text-small zx-text-sm-medium">
                <b class="zx-text-tiny pb-2 opacity-75">
                  {{ 'su-management.order-num-of-pages' | translate }}
                </b>
                <span class="zx-text-small zx-text-sm-medium">
                  <span *ngIf="getQueueCurrentOrderAmountOfPages() === 1">
                    {{ 'su-management.one-page' | translate }}
                  </span>
                  <span *ngIf="getQueueCurrentOrderAmountOfPages() > 1">
                    <span>
                      {{ getQueueCurrentOrderAmountOfPages() }}
                    </span>
                    <span>
                      {{ 'su-management.pages' | translate }}
                    </span>
                  </span>
                </span>
              </div>
              <!-- // amount of pages [express] -->

            </div>
            <!-- // --------------- queue status = full --------------- -->

            <!-- --------------- printer status line #2 --------------- -->
            <div class="d-flex row pt-3">
              <!-- last printed at -->
              <div class="col-4 col-md-3 col-lg-2 d-flex flex-column gap-lg-1">
                <b class="zx-text-tiny pb-2 opacity-75">
                  {{ 'su-management.last-printed-at' | translate }}
                </b>
                <span class="zx-text-small zx-text-sm-medium">
                  {{ getLastPrintedAtTime() }}
                </span>
                <span class="zx-text-tiny">
                  {{ getLastPrintedAtDate() }}
                </span>
              </div>
              <!-- printer model -->
              <div class="col-8 col-md-9 col-lg-10 d-flex flex-column gap-lg-1">
                <b class="zx-text-tiny pb-2 opacity-75">
                  {{ 'su-management.printer-model' | translate }}
                </b>
                <div class="w-100 d-flex flex-column gap-lg-1">
                  <span class="zx-text-small zx-text-sm-medium">
                    {{ getPrinterModel() }}
                  </span>
                </div>
              </div>

            </div>
            <!-- // --------------- printer status line #2 --------------- -->

            <div class="d-flex w-100 zx-border-bottom-gray-v-light-mid my-4"></div>

            <!-- --------------- PAPERS and INK line --------------- -->
            <div class="d-flex row">

              <!-- ---------- PAPERS status ---------- -->
              <div class="col-12 d-flex flex-column align-items-center gap-lg-1" *ngIf="!isLoadUsers">
                <b class="zx-text-tiny zx-text-sm-small text-green w-100 text-center pb-2">
                  {{ 'su-management.paper-status' | translate }}
                </b>
                <div class="d-flex w-100 row zx-border-bottom-green-bold mt-2 mb-3"></div>
                <article class="row w-100">
                  <div *ngFor="let paper of getConsumables('paper')"
                    class="col-12 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center"
                    [class.col-lg-6]="printingService === 'express'">
                    <div class="row w-100">
                      <!-- paper title -->
                      <div class="col-6 d-flex justify-content-center align-items-center">
                        <b class="zx-text-small zx-text-sm-medium">
                          <span *ngIf="printingService === 'plotter'">
                            {{ 'paper-type.name.' + paper.paperType.paperType | translate }}
                          </span>
                          <span *ngIf="printingService === 'express'">
                            {{ 'paper-type.name.' + paper.serial_name | translate }}
                          </span>
                        </b>
                      </div>
                      <!-- // paper title -->

                      <!-- paper weight and width -->
                      <div
                        class="col-6 d-flex flex-column flex-md-row gap-md-5 justify-content-md-end align-items-center px-lg-3">
                        <span>
                          <span class="zx-text-tiny">
                            <span *ngIf="printingService === 'plotter'">
                              {{ paper.paperType.paperWeight }}
                            </span>
                            <span *ngIf="printingService === 'express'">
                              {{ getPaperProperties('weight', paper) }}
                            </span>
                          </span>
                          <span class="zx-text-tiny-tiny">
                            {{ 'su-management.branches_paper-weight-g' | translate }}
                          </span>
                        </span>
                        <span>
                          <span class="zx-text-tiny">
                            <span *ngIf="printingService === 'plotter'">
                              {{ roundDownTowDecimal(paper.paperType.paperWidth / 10) }}
                            </span>
                            <span *ngIf="printingService === 'express'">
                              <span>
                                {{ getPaperProperties('height', paper) }}
                              </span>
                              <span>
                                ×
                              </span>
                              <span>
                                {{ getPaperProperties('width', paper) }}
                              </span>
                            </span>
                          </span>
                          <span class="zx-text-tiny-tiny">
                            {{ 'printing-table.dimensions-cm' | translate }}
                          </span>
                        </span>
                      </div>
                      <!-- // paper weight and width -->

                      <div class="col-12 d-flex w-100 zx-border-bottom-gray-v-light-mid my-1 my-md-2"></div>

                      <!-- paper status -->
                      <div class="col-6 col-sm-4 col-xl-3 d-flex flex-column align-items-center pt-2 gap-sm-1"
                        [class.w-100]="branch?.isPicsPrinter">
                        <span class="zx-text-tiny opacity-75">
                          {{ 'su-management.branches_paper-detection' | translate }}
                        </span>
                        <b class="zx-text-small zx-text-sm-medium">
                          <span class="text-green" *ngIf="getPaperStatus(paper)">
                            {{ 'su-management.branches_paper-detection-true' | translate }}
                          </span>
                          <span class="text-red" *ngIf="!getPaperStatus(paper)">
                            {{ 'su-management.branches_paper-detection-false' | translate }}
                          </span>
                        </b>
                      </div>
                      <!-- // paper status -->

                      <!-- paper length (in meters) [plotter] -->
                      <div *ngIf="printingService === 'plotter'"
                        class="col-6 col-sm-4 col-xl-3 d-flex flex-column align-items-center pt-2 gap-sm-1">
                        <span class="zx-text-tiny opacity-75">
                          {{ 'su-management.branches_paper-linger-length' | translate }}
                        </span>
                        <b class="zx-text-small zx-text-sm-medium"
                          [class.text-green]="paper.status?.lingerLength && paper.status.lingerLength >= 10"
                          [class.text-red]="paper.status?.lingerLength && paper.status.lingerLength < 10">
                          <span>
                            {{ roundDownFourDecimal(paper.status.lingerLength) }}
                          </span>
                          <span class="zx-text-tiny-tiny">
                            {{ 'su-management.branches_m' | translate }}
                          </span>
                        </b>
                        <!-- total paper in queue -->
                        <span class="text-green" *ngIf="getTotalPaperLengthInQueue(paper)">
                          <span>(</span>
                          <span>{{getTotalPaperLengthInQueue(paper)}}</span>
                          <span class="zx-text-tiny-tiny">
                            {{ 'su-management.branches_m' | translate }}
                          </span>
                          <span class="zx-text-tiny-tiny">
                            {{ 'su-management.branches_in-queue' | translate }}
                          </span>
                          <span>)</span>
                        </span>
                        <!-- // total paper in queue -->
                      </div>
                      <!-- // paper length (in meters) [plotter] -->

                      <!-- paper physical Input Bin -->
                      <div *ngIf="!branch?.isPicsPrinter"
                        class="col-6 col-sm-4 col-xl-2 d-flex flex-column align-items-center pt-2 gap-sm-1">
                        <span class="zx-text-tiny opacity-75">
                          {{ 'su-management.phisical-input-bin' | translate }}
                        </span>
                        <span class="zx-text-small zx-text-sm-medium">
                          <span>
                            {{ getPhisicalInputBinNumber(paper) | translate }}
                          </span>
                        </span>
                      </div>
                      <!-- // paper physical Input Bin -->

                      <!-- paper needs to Replace ? [plotter] -->
                      <div *ngIf="printingService === 'plotter'"
                        class="col-6 col-sm-4 col-xl-2 d-flex flex-column align-items-center pt-2 gap-sm-1">
                        <span class="zx-text-tiny opacity-75">
                          {{ 'su-management.needs-to-replace' | translate }}
                        </span>
                        <span class="zx-text-small zx-text-sm-medium d-flex flex-column align-items-center">
                          <span *ngIf="getIsConsumableNeedsToReplase('paper', paper) === 0">
                            {{ 'su-management.needs-to-replace.no' | translate }}
                          </span>
                          <span class="text-red" *ngIf="getIsConsumableNeedsToReplase('paper', paper) === 1">
                            {{ 'su-management.needs-to-replace.soon' | translate }}
                          </span>
                          <b class="text-red" *ngIf="getIsConsumableNeedsToReplase('paper', paper) === 2">
                            {{ 'su-management.needs-to-replace.yes' | translate }}
                          </b>
                        </span>
                      </div>
                      <!-- // paper needs to Replace ? [plotter] -->

                      <!-- paper inventory ? -->
                      <div *ngIf="!branch?.isPicsPrinter"
                        class="col-12 col-sm-4 col-xl-2 d-flex flex-column align-items-center pt-2 gap-sm-1">
                        <span class="zx-text-tiny opacity-75">
                          {{ 'su-management.inventory-management.short' | translate }}
                        </span>
                        <span class="zx-text-small zx-text-sm-medium"
                          [class.text-red]="getCurrentStock('paper', paper) < 1"
                          [class.fw-bold]="getCurrentStock('paper', paper) < 1">
                          <span>
                            {{ getCurrentStock('paper', paper) }}
                          </span>
                          <span class="zx-text-tiny-tiny">
                            {{ 'su-management.units.short' | translate }}
                          </span>
                        </span>
                      </div>
                      <!-- // paper inventory ? -->

                    </div>
                  </div>
                </article>
              </div>
              <!-- // ---------- PAPERS status ---------- -->

              <!-- ---------- INK status ---------- -->
              <div class="col-12 d-flex flex-column gap-lg-1 pt-4" *ngIf="!branch?.isPicsPrinter">
                <b class="zx-text-tiny zx-text-sm-small text-green w-100 text-center pb-2">
                  {{ 'su-management.ink-status' | translate }}
                </b>
                <div class="d-flex w-100 zx-border-bottom-green-bold mt-2 mb-3"></div>

                <div *ngIf="!isLoading" class="w-100 d-flex justify-content-center">
                  <div class="d-flex w-100 row">
                    <div *ngFor="let ink of getConsumables('ink')"
                      class="col-12 col-md-6 col-xl-4 col-xxl-3 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center">
                      <div class="row w-100">
                        <!-- ink title -->
                        <div class="col-6 d-flex justify-content-center align-items-center">
                          <b class="zx-text-small zx-text-sm-medium">
                            <span *ngIf="printingService === 'plotter'">
                              {{ ink.color }}
                            </span>
                            <span *ngIf="printingService === 'express'">
                              {{ ink.name }}
                            </span>
                          </b>
                        </div>
                        <!-- // ink title -->

                        <!-- ink description -->
                        <div
                          class="col-6 d-flex flex-column flex-md-row gap-md-5 justify-content-md-center align-items-center px-lg-5">
                          <span *ngIf="printingService === 'plotter'" class="zx-text-tiny">
                            {{ 'ink-type.name.' + ink.color | translate }}
                          </span>
                          <span *ngIf="printingService === 'express'" class="zx-text-tiny">
                            {{ 'ink-type.name.' + ink.name | translate }}
                          </span>
                        </div>
                        <!-- // ink weight and width -->

                        <div class="col-12 d-flex w-100 zx-border-bottom-gray-v-light-mid my-1 my-md-2"></div>

                        <!-- ink status -->
                        <div class="col-6 col-sm-3 d-flex flex-column align-items-center pt-2 gap-sm-1">
                          <span class="zx-text-tiny opacity-75">
                            {{ 's-screen.plotter-que.title.status' | translate }}
                          </span>
                          <b [class.text-green]="getIsConsumableNeedsToReplase('ink', ink) === 0"
                            [class.text-red]="getIsConsumableNeedsToReplase('ink', ink) === 1 || getIsConsumableNeedsToReplase('ink', ink) === 2">
                            <span class="zx-text-tiny">%</span>
                            <span class="zx-text-small zx-text-sm-medium">
                              {{ ink.level }}
                            </span>
                          </b>
                        </div>
                        <!-- // ink status -->

                        <!-- ink needs to Replace ? -->
                        <div class="col-6 d-flex flex-column align-items-center pt-2 gap-sm-1">
                          <span class="zx-text-tiny opacity-75">
                            {{ 'su-management.needs-to-replace' | translate }}
                          </span>
                          <span class="zx-text-small zx-text-sm-medium">
                            <span *ngIf="getIsConsumableNeedsToReplase('ink', ink) === 0">
                              {{ 'su-management.needs-to-replace.no' | translate }}
                            </span>
                            <span class="text-red" *ngIf="getIsConsumableNeedsToReplase('ink', ink) === 1">
                              {{ 'su-management.needs-to-replace.soon' | translate }}
                            </span>
                            <div class="d-flex flex-column align-items-center"
                              *ngIf="getIsConsumableNeedsToReplase('ink', ink) === 2">
                              <b class="text-red">
                                {{ "su-management.needs-to-replace.yes" | translate }}
                              </b>
                            </div>
                          </span>
                        </div>
                        <!-- // ink needs to Replace ? -->

                        <!-- ink inventory ? -->
                        <div class="col-12 col-sm-3 d-flex flex-column align-items-center pt-2 gap-sm-1">
                          <span class="zx-text-tiny opacity-75">
                            {{ 'su-management.inventory-management.short' | translate }}
                          </span>
                          <span class="zx-text-small zx-text-sm-medium"
                            [class.text-red]="getCurrentStock('ink', ink) < 1"
                            [class.fw-bold]="getCurrentStock('ink', ink) < 1">
                            <span>
                              {{ getCurrentStock('ink', ink) }}
                            </span>
                            <span class="zx-text-tiny-tiny">
                              {{ 'su-management.units.short' | translate }}
                            </span>
                          </span>
                        </div>
                        <!-- // ink inventory ? -->

                      </div>
                    </div>
                    <!-- wastetanck [plotter] -->
                    <div *ngIf="printingService === 'plotter'"
                      class="col-12 col-xl-4 col-xxl-12 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center">
                      <div class="row w-100">
                        <!-- wastetanck title -->
                        <div class="col-6 d-flex justify-content-center align-items-center">
                          <b class="zx-text-small zx-text-sm-medium">
                            {{ 'ink-type.name.Waste' | translate }}
                          </b>
                        </div>
                        <!-- // wastetanck title -->

                        <div class="col-12 d-flex w-100 zx-border-bottom-gray-v-light-mid my-1 my-md-2"></div>

                        <!-- wastetanck status -->
                        <div class="col-6 col-sm-3 d-flex flex-column align-items-center pt-2 gap-sm-1">
                          <span class="zx-text-tiny opacity-75">
                            {{ 's-screen.plotter-que.title.status' | translate }}
                          </span>
                          <b [class.text-green]="this.branch.printers && branch.printers[0]?.wasteInk?.level < 90"
                            [class.text-red]="this.branch.printers && branch.printers[0]?.wasteInk?.level >= 90">
                            <span class="zx-text-tiny">%</span>
                            <span *ngIf="branch.printers" class="zx-text-small zx-text-sm-medium">
                              {{ branch.printers[0].wasteInk?.level }}
                            </span>
                          </b>
                        </div>
                        <!-- // wastetanck status -->

                        <!-- wastetanck needs to Replace ? -->
                        <div class="col-6 d-flex flex-column align-items-center pt-2 gap-sm-1">
                          <span class="zx-text-tiny opacity-75">
                            {{ 'su-management.needs-to-replace' | translate }}
                          </span>
                          <span class="zx-text-small zx-text-sm-medium">
                            <span *ngIf="branch.printers && branch.printers[0].wasteInk?.level < 90">
                              {{ 'su-management.needs-to-replace.no' | translate }}
                            </span>
                            <span class="text-red"
                              *ngIf="branch.printers && branch.printers[0].wasteInk?.level >= 90 && branch.printers[0].wasteInk?.level < 100">
                              {{ 'su-management.needs-to-replace.soon' | translate }}
                            </span>
                            <b class="text-red"
                              *ngIf="branch.printers && branch.printers[0].wasteInk?.enableReplace && branch.printers[0].wasteInk?.level === 100">
                              {{ 'su-management.needs-to-replace.yes' | translate }}
                            </b>
                          </span>
                        </div>
                        <!-- // wastetanck needs to Replace ? -->

                        <!-- wastetanck inventory ? -->
                        <div *ngIf="printingService === 'plotter'"
                          class="col-12 col-sm-3 d-flex flex-column align-items-center pt-2 gap-sm-1">
                          <span class="zx-text-tiny opacity-75">
                            {{ 'su-management.inventory-management.short' | translate }}
                          </span>
                          <span *ngIf="branch.printers" class="zx-text-small zx-text-sm-medium"
                            [class.text-red]="getCurrentStock('wastetanck', branch.printers[0].wasteInk) < 1"
                            [class.fw-bold]="getCurrentStock('wastetanck', branch.printers[0].wasteInk) < 1">
                            <span>
                              {{ getCurrentStock('wastetanck', branch.printers[0].wasteInk) }}
                            </span>
                            <span class="zx-text-tiny-tiny">
                              {{ 'su-management.units.short' | translate }}
                            </span>
                          </span>
                        </div>
                        <!-- // wastetanck inventory ? -->

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- // ---------- INK status ---------- -->


            </div>
            <!-- // --------------- PAPERS line --------------- -->

          </div>
        </div>
        <!-- // content -->
      </mat-tab>
      <!-- // ===== ===== ===== ===== ===== ===== printer ===== ===== ===== ===== ===== ===== -->

















































      <!-- ===== ===== ===== ===== ===== ===== orders ===== ===== ===== ===== ===== ===== -->
      <mat-tab [disabled]="!isManiger() || isLoadingTabChange" class="w-100 d-flex flex-grow-1 flex-column"
        label="orders">
        <ng-template mat-tab-label>
          <div class="d-flex flex-column flex-lg-row-reverse align-items-center justify-content-center gap-1 gap-lg-2">
            <b class="zx-text-tiny-tiny zx-text-sm-small">
              {{ 'su-management.orders-management.short' | translate }}
            </b>
            <mat-icon>assignment</mat-icon>
          </div>
        </ng-template>
        <!-- content -->
        <div class="w-100 d-flex h-100 flex-column">
          <div class="w-100 d-flex flex-grow-1 flex-column py-3 px-lg-5">

            <!-- --------------- title --------------- -->
            <div class="w-100 d-flex justify-content-center px-3">
              <div class="w-100 d-flex justify-content-center zx-border-bottom-green-bold mb-4 pb-2 px-3 px-lg-5">
                <h6 class="fw-bold zx-text-medium zx-text-sm-big" [class.text-green]="!isDarkMode">
                  {{ 'su-management.orders-management' | translate }}
                </h6>
              </div>
            </div>
            <!-- // --------------- title --------------- -->

            <div class="w-100 d-flex flex-grow-1 flex-column">

              <!-- LOADING... orders -->
              <div *ngIf="!(subPage === 'orders' && orders?.length > 0 && !isLoading && !isLoadOrders)"
                class="fill-height px-2 pb-2 d-flex justify-content-center align-items-center px-xl-5">
                <mat-spinner class="zx-medium-icon-size zx-medium-big-icon-size-lg"></mat-spinner>
              </div>

              <!-- finished LOADING... orders -->
              <div *ngIf="subPage === 'orders' && orders?.length > 0 && !isLoading && !isLoadOrders"
                class="fill-height px-2 pb-2 d-flex justify-content-center px-xl-5">
                <!-- orders -------------------------------------------------------------------------------------------------------- orders -->
                <section class="w-100 d-flex flex-column">
                  <!-- orders accordion -->
                  <mat-accordion #scrollContainerOrders class="w-100 pb-3" multi="false"
                    *ngIf="orders.length > 0 && !isLoading">

                    <mat-expansion-panel *ngFor="let order of orders; index as o" (opened)="isAllImagesShowen = false"
                      (closed)="isAllImagesShowen = false" [expanded]="order._id === expandedPanelIdOrders"
                      [attr.data-order-id]="order._id">
                      <mat-expansion-panel-header (click)="togglePanelOrders(order)"
                        [class.zx-choosen-order]="expandedPanelIdOrders === order._id"
                        [class.zx-big-order-header]="!isAllFilesHavePaperSet(order)" [class.orders-header]="isSU">
                        <article class="w-100 d-flex flex-column">

                          <!-- title -->
                          <article *ngIf="order.user"
                            class="w-100 d-flex align-items-center justify-content-between pt-1 pb-2 pt-xl-0 pb-xl-3">
                            <b>
                              <span class="d-lg-none">
                                {{ order.user | slice:0:17 }}
                              </span>
                              <span *ngIf="order.user.length > 17" class="d-lg-none">
                                ...
                              </span>
                              <span class="d-none d-lg-inline">
                                {{ order.user }}
                              </span>
                            </b>
                            <b *ngIf="order.status && order.status !== ''"
                              class="px-4 px-sm-5 zx-text-gray-dark-not-imp" [class.text-red]="order.status === 'EXPIRED' ||
                            order.status === 'REFUNDED' ||
                            order.status === 'REFUNDED_POINTS' ||
                            order.status === 'CANCELLED' ||
                            order.status === 'ERROR'" [class.text-green]="order.status === 'PROCESSING' ||
                            order.status === 'INQUEUE' ||
                            order.status === 'PRINTERQUEUE' ||
                            order.status === 'DONE'">
                              <span *ngIf="!order.isDeleted">
                                {{ "my-orders.status." + order.status | translate }}
                              </span>
                              <span *ngIf="order.isDeleted" class="text-red">
                                {{ "my-orders.status.CANCELLED" | translate }}
                              </span>
                            </b>
                          </article>
                          <!-- // title -->

                          <!-- maniger options -->
                          <div *ngIf="isSU"
                            class="d-flex gap-lg-2 pt-3 align-items-center justify-content-end zx-min-w-btn zx-copy-btn"
                            [class.zx-copy-btn-not-rtl]="!isRTL">
                            <!-- error -->
                            <div *ngIf="order.hasErrors && order.hasErrors === true"
                              class="d-flex col-3 col-lg-1 align-items-lg-center justify-content-end px-3">
                              <mat-icon class="text-red zx-text-big flex-shrink-0"
                                [matTooltip]="'su-management.order-with-error' | translate"
                                [matTooltipPosition]="'above'">warning</mat-icon>
                            </div>

                            <button mat-icon-button color="secondary" class="rounded-pill zx-text-tiny small-btn p-0"
                              [matMenuTriggerFor]="manigerManu" (click)="stopEvent($event)">
                              <img class="zx-small-icon-size svg c-pointer" src="assets/images/three-dots-icon.svg"
                                alt="Image Options">
                            </button>
                            <mat-menu #manigerManu="matMenu">
                              <!-- error -->
                              <div *ngIf="order.hasErrors && order.hasErrors === true" mat-icon-button class="d-flex">
                                <div class="d-flex flex-grow-1 gap-4 m-2 text-red"
                                  [matTooltip]="'su-management.order-with-error' | translate"
                                  [matTooltipPosition]="'above'">
                                  <mat-icon class="zx-text-medium zx-text-sm-big pt-1 text-red">warning</mat-icon>
                                  <span class="d-flex flex-grow-1">
                                    {{ ("su-management.order-with-error" | translate) | slice:0:15 }}...
                                  </span>
                                </div>
                              </div>
                              <!-- delete -->
                              <button *ngIf="!order.isDeleted && !order.addedToQueue" color="secondary" mat-menu-item
                                (click)="openDeleteOrderDialog($event, order)">
                                <div class="d-flex gap-4">
                                  <img class="zx-small-tiny-icon-size zx-small-icon-size-lg svg delete-on-hover"
                                    [src]="'assets/images/delete-icon.svg'" [class.bg-light-darkmode]="isDarkMode"
                                    [class.rounded-circle]="isDarkMode">
                                  <span class="d-flex flex-grow-1">
                                    {{ "delete-order.title" | translate }}
                                  </span>
                                </div>
                              </button>
                              <!-- go to orders -->
                              <button color="secondary" mat-menu-item
                                (click)="showUsersOrders(order, true); $event.stopPropagation()">
                                <div class="d-flex gap-1">
                                  <mat-icon class="zx-text-medium zx-text-sm-big pt-1">list_alt</mat-icon>
                                  <span class="d-flex flex-grow-1">
                                    {{ "my-profile.go-to-order-many" | translate }}
                                  </span>
                                </div>
                              </button>
                              <!-- go to user -->
                              <button color="secondary" mat-menu-item
                                (click)="showUser(order); $event.stopPropagation()">
                                <div class="d-flex gap-1">
                                  <mat-icon class="zx-text-medium zx-text-sm-big pt-1">perm_identity</mat-icon>
                                  <span class="d-flex flex-grow-1">
                                    {{ "su-management.users.show-user" | translate }}
                                  </span>
                                </div>
                              </button>
                              <!-- download all files -->
                              <button color="secondary" mat-menu-item
                                (click)="onDownloadOrderOriginalFiles(printingService, order); $event.stopPropagation()">
                                <div class="d-flex gap-1">
                                  <mat-icon class="zx-text-medium zx-text-sm-big pt-1">cloud_download</mat-icon>
                                  <span class="d-flex flex-grow-1">
                                    {{ "su-management.users.download-files" | translate }}
                                  </span>
                                </div>
                              </button>
                              <!-- copy details -->
                              <button color="secondary" mat-menu-item
                                (click)="copyOrderDetails(order); $event.stopPropagation()">
                                <div class="d-flex gap-1">
                                  <mat-icon class="zx-text-medium zx-text-sm-big pt-1">content_copy</mat-icon>
                                  <span class="d-flex flex-grow-1">
                                    {{ "su-management.copy-order-details" | translate }}
                                  </span>
                                </div>
                              </button>
                              <!-- resend-order -->
                              <button
                                *ngIf="order.addedToQueue && !order.isDeleted && !(order.hasErrors && order.hasErrors === true)"
                                mat-menu-item color="secondary" class="small-btn" [matMenuTriggerFor]="resentOrderManu"
                                (click)="stopEvent($event)">
                                <div class="d-flex align-items-center gap-1">
                                  <mat-icon class="zx-text-medium zx-text-sm-big pt-1">refresh</mat-icon>
                                  <span class="d-flex">
                                    {{ "su-management.resend-order" | translate }}
                                  </span>
                                </div>
                              </button>
                              <mat-menu #resentOrderManu="matMenu">
                                <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL"
                                  mat-menu-item (click)="resendOrder(order)">
                                  <b class="text-green m-0 zx-text-small" [class.zx-text-white]="isDarkMode">
                                    {{ 'su-management.resend-order' | translate }}
                                  </b>
                                  <mat-icon class="text-green mx-1 p-0 zx-pt-small"
                                    [class.zx-text-white]="isDarkMode">refresh</mat-icon>
                                </button>
                              </mat-menu>
                              <!-- refund-order -->
                              <button
                                *ngIf="(order.addedToQueue || order.is_only_fix_products_in_order) && !order.isDeleted && order.status !== 'REFUNDED'"
                                mat-menu-item color="secondary" class="small-btn" [matMenuTriggerFor]="refundOrderManu"
                                (click)="stopEvent($event)">
                                <div class="d-flex align-items-center gap-1">
                                  <mat-icon class="zx-text-medium zx-text-sm-big pt-1">money_off</mat-icon>
                                  <span class="d-flex">
                                    {{ "su-management.cancel-order" | translate }}
                                  </span>
                                </div>
                              </button>
                              <mat-menu #refundOrderManu="matMenu">
                                <button *ngIf="order.status !== 'REFUNDED_POINTS' && !order.fix_products_order"
                                  class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
                                  (click)="cancelOrder(order, 'REFUNDED_POINTS')">
                                  <b class="text-green m-0 zx-text-small" [class.zx-text-white]="isDarkMode">
                                    {{ 'su-management.cancel-order.REFUNDED_POINTS' | translate }}
                                  </b>
                                  <mat-icon class="text-green mx-1 p-0 zx-pt-small pt-1"
                                    [class.zx-text-white]="isDarkMode">money_off</mat-icon>
                                </button>
                                <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL"
                                  mat-menu-item (click)="cancelOrder(order, 'REFUNDED')">
                                  <b class="text-green m-0 zx-text-small" [class.zx-text-white]="isDarkMode">
                                    {{ 'su-management.cancel-order.REFUNDED' | translate }}
                                  </b>
                                  <mat-icon class="text-green mx-1 p-0 zx-pt-small pt-1"
                                    [class.zx-text-white]="isDarkMode">attach_money</mat-icon>
                                </button>
                              </mat-menu>
                            </mat-menu>
                            <!-- // maniger options -->

                          </div>

                          <article class="w-100 d-flex align-items-center justify-content-between">
                            <!-- ** main container ** -->
                            <article class="d-flex flex-column flex-grow-1 gap-1 gap-lg-2">
                              <!-- MAIN row -->
                              <div
                                class="d-flex flex-column flex-lg-row-reverse flex-grow-1 gap-1 gap-lg-4 align-items-lg-center">

                                <!-- files and price -->
                                <div class="d-flex align-items-center gap-2 gap-lg-3 flex-grow-1">
                                  <span class="zx-text-tiny zx-text-sm-small">
                                    <!-- files -->
                                    <span *ngIf="!order.is_only_fix_products_in_order">
                                      <span *ngIf="order.files.length > 1 ||
                                        (!order.files || order.files.length === 0)">
                                        <span>
                                          {{ order.files.length }}
                                        </span>
                                        <span class="zx-text-tiny">
                                          {{ "printing-table.files" | translate }}
                                        </span>
                                      </span>
                                      <span *ngIf="order.files?.length === 1">
                                        <span class="zx-text-tiny">
                                          {{ "printing-table.one-file" | translate }}
                                        </span>
                                      </span>
                                    </span>
                                    <!-- , -->
                                    <span
                                      *ngIf="order.fix_products_order?.products?.length > 0 && order.files?.length > 0">,
                                    </span>
                                    <!-- fix products -->
                                    <span *ngIf="order.fix_products_order?.products?.length > 0">
                                      <span *ngIf="getAmountOfFixProducts(order.fix_products_order.products) > 1">
                                        <span>
                                          {{ getAmountOfFixProducts(order.fix_products_order.products) }}
                                        </span>
                                        <span class="zx-text-tiny">
                                          {{ "fix-products.num-of-products.many" | translate }}
                                        </span>
                                      </span>
                                      <span *ngIf="getAmountOfFixProducts(order.fix_products_order.products) === 1">
                                        <span class="zx-text-tiny">
                                          {{ "fix-products.num-of-products.one" | translate }}
                                        </span>
                                      </span>
                                    </span>

                                    <!-- , -->
                                    <span>, </span>
                                    <!-- before discount price - order discounted -->
                                    <span class="opacity-75 zx-text-tiny"
                                      *ngIf="order.discount && order.discount !== 0 && !order.adminOrder">
                                      <span class="strikethrough">
                                        <span>
                                          {{ roundDownTowDecimalCeil(order.totalCost + order.discount +
                                          getOrderFixProductsPrice(order)) }}
                                        </span>
                                        <span>
                                          {{ 'printing-table.nis' | translate }}
                                        </span>
                                      </span>
                                      <span class="zx-100-opacity">.</span>
                                      <span class="zx-text-tiny-tiny text-green">
                                        <span>( %</span>
                                        <span>
                                          {{ roundDownTowDecimalCeil(
                                          100 - ((((order.totalCost + order.discount) - order.discount) /
                                          (order.totalCost +
                                          order.discount))
                                          * 100))
                                          }}
                                        </span>
                                        <span>
                                          {{ "my-orders.discount" | translate }}
                                        </span>
                                        <span>)</span>
                                      </span>
                                      <span class="zx-100-opacity">.</span>
                                    </span>
                                    <!-- normal user -->
                                    <span>
                                      <!-- total cost -->
                                      <span>
                                        {{ roundDownTowDecimalCeil(order.totalCost + getOrderFixProductsPrice(order)) }}
                                      </span>
                                      <span class="zx-text-tiny">
                                        {{ "printing-table.nis" | translate }}
                                      </span>
                                    </span>
                                    <!-- order with points -->
                                    <span *ngIf="order.pointsCost && order.pointsCost > 0">
                                      <span>(</span>
                                      <span>{{ roundDownTowDecimalCeil(order.pointsCost) }}</span>
                                      <span class="zx-text-tiny">
                                        {{ "printing-table.points-short" | translate }}
                                      </span>
                                      <span class="zx-100-opp">.</span>
                                      <span>+</span>
                                      <span class="zx-100-opp">.</span>
                                      <span>{{ roundDownTowDecimalCeil(order.ccCost + getOrderFixProductsPrice(order))
                                        }}</span>
                                      <span class="zx-text-tiny">
                                        {{ "printing-table.nis" | translate }}
                                      </span>
                                      <span>)</span>
                                    </span>
                                    <!-- manager user - admin order -->
                                    <span *ngIf="order.adminOrder">
                                      <span class="zx-100-opacity">-</span>
                                      <span class="zx-text-tiny-tiny zx-text-sm-tiny zx-text-pink fw-bold"
                                        [class.zx-text-white]="isDarkMode">
                                        <span>(</span>
                                        <span>
                                          {{ "my-orders.manager-order" | translate }}
                                        </span>
                                        <span>)</span>
                                      </span>
                                    </span>

                                  </span>
                                </div>

                                <div class="zx-seperation-v-line d-none d-lg-flex"></div>

                                <!-- status and times -->
                                <div class="d-flex col-12 col-lg-6 align-items-center px-3">
                                  <div
                                    class="d-flex align-items-center w-100 rounded-pill bg-white-50-pr shadow-85-light">

                                    <!-- created -->
                                    <div class="d-flex justify-content-center zx-status-con-30-p">
                                      <div class="d-flex flex-column">
                                        <b class="zx-text-tiny text-green">
                                          {{ "my-orders.created" | translate }}
                                        </b>
                                        <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                          <span class="zx-text-tiny">
                                            {{ order.created | date:'dd/MM/yy' }}
                                          </span>
                                          <span class="zx-text-tiny">
                                            {{ order.created | date:'HH:mm' }}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- // created -->

                                    <!-- >>> -->
                                    <img class="object-fit-cover zx-seperation-arrow zx-status-con-10-p"
                                      [class.mirror]="!isRTL" src="../../assets/images/seperation-arrow.svg">

                                    <!-- sent to print? -->
                                    <!-- NO, BUT POSSIBLE! (sent to print?) -->
                                    <div *ngIf="!order.addedToQueue &&
                                         (order.status === 'PENDING' ||
                                          order.status === 'QR' ||
                                          order.status === 'NOT_PAID') &&
                                        (!order.files || order.files.length > 0) &&
                                        !order.isDeleted"
                                      class="d-flex flex-column flex-shrink-0 zx-status-con-70-p px-3">
                                      <!-- [print btn] -->
                                      <button mat-raised-button color="primary" class="print-button rounded-pill d-flex"
                                        [disabled]="!isSU">
                                        <span class="zx-text-sm-small text-white">
                                          {{ "printing-table.send-to-print" | translate }}
                                        </span>
                                      </button>
                                    </div>

                                    <!-- NO, BUT NOT POSSIBLE! NO FILES! (sent to print?) -->
                                    <div *ngIf="!order.addedToQueue &&
                                             (order.status === 'PENDING' ||
                                              order.status === 'QR' ||
                                              order.status === 'NOT_PAID') &&
                                             !(!order.files || order.files.length > 0)"
                                      class="d-flex flex-column zx-status-con-70-p">
                                      <!-- [whatsup btn] -->
                                      <div class="d-flex flex-column gap-1 align-items-center pb-3 px-2">
                                        <b class="text-red zx-text-tiny-tiny zx-text-sm-tiny"
                                          [class.zx-text-white]="isDarkMode">
                                          {{'my-orders.contact-us-no-files-order' | translate}}
                                        </b>
                                        <button mat-raised-button class="rounded-pill zx-text-tiny zx-text-sm-small">
                                          <div class="w-100 h-100 d-flex align-items-center gap-2">
                                            <div class="whatsup-logo-container-small">
                                              <img src="assets/images/whatsup-logo.svg" alt="WhatsUp Logo"
                                                class="whatsup-logo-small">
                                            </div>
                                            <span class="zx-text-tiny-tiny">
                                              {{'main-nav.contact-us' | translate}}
                                            </span>
                                          </div>
                                        </button>
                                      </div>
                                    </div>

                                    <!-- YES (sent to print?) -->
                                    <div *ngIf="order.addedToQueue"
                                      class="d-flex justify-content-center zx-status-con-30-p">
                                      <div class="d-flex flex-column">
                                        <b class="zx-text-tiny text-green">
                                          {{ "my-orders.added-to-queue" | translate }}
                                        </b>
                                        <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                          <span class="zx-text-tiny">
                                            {{ order.addedToQueue | date:'dd/MM/yy' }}
                                          </span>
                                          <span class="zx-text-tiny">
                                            {{ order.addedToQueue | date:'HH:mm' }}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- // YES (sent to print?) -->

                                    <!-- >>> -->
                                    <img *ngIf="order.addedToQueue && (
                                      order.status === 'DONE'||
                                      order.status === 'REFUNDED' ||
                                      order.status === 'REFUNDED_POINTS' ||
                                      order.status === 'CANCELLED')"
                                      class="object-fit-cover zx-seperation-arrow zx-status-con-10-p"
                                      [class.mirror]="!isRTL" src="../../assets/images/seperation-arrow.svg">

                                    <!-- printed? -->
                                    <!-- NO, AND NOT POSSIBLE! (EXPIRED or REFUNDED) (printed?) -->
                                    <div *ngIf="order.status === 'EXPIRED' ||
                                         order.status === 'REFUNDED' ||
                                         order.status === 'REFUNDED_POINTS' ||
                                         order.status === 'CANCELLED' ||
                                         order.isDeleted" class="d-flex flex-column zx-status-con-30-p"
                                      [class.zx-status-con-70-p]="!order.addedToQueue">
                                      <!-- EXPIRED -->
                                      <div *ngIf="order.status === 'EXPIRED' && !order.isDeleted"
                                        class="d-flex flex-column align-items-center justify-content-center gap-1">
                                        <b class="zx-text-tiny text-red text-center" [class.zx-text-white]="isDarkMode">
                                          {{ "my-orders.order-expired" | translate }}
                                        </b>
                                        <span class="zx-text-tiny-tiny text-red text-center"
                                          [class.zx-text-white]="isDarkMode">
                                          {{ "my-orders.order-expired-explain" | translate }}
                                        </span>
                                      </div>
                                      <!-- REFUNDED | REFUNDED_POINTS | CANCELLED | isDeleted -->
                                      <div *ngIf="order.status === 'REFUNDED' ||
                                              order.status === 'REFUNDED_POINTS' ||
                                              order.status === 'CANCELLED' ||
                                              order.isDeleted"
                                        class="d-flex flex-column align-items-center justify-content-center gap-1">
                                        <b class="zx-text-tiny text-green text-center">
                                          {{ "my-orders.order-refunded" | translate }}
                                        </b>
                                        <span class="zx-text-tiny-tiny text-green text-center">
                                          <span *ngIf="order.status === 'REFUNDED'">
                                            {{ "my-orders.order-refunded-explain" | translate }}
                                          </span>
                                          <span *ngIf="order.status === 'REFUNDED_POINTS'">
                                            {{ "my-orders.order-refunded-explain.points" | translate }}
                                          </span>
                                          <span *ngIf="order.status === 'CANCELLED'">
                                            {{ "my-orders.order-refunded-explain.no-refund" | translate }}
                                          </span>
                                        </span>
                                      </div>
                                    </div>

                                    <!-- YES (printed?) -->
                                    <div *ngIf="order.addedToQueue && order.status === 'DONE'"
                                      class="d-flex justify-content-center zx-status-con-30-p">
                                      <div class="d-flex flex-column">
                                        <b class="zx-text-tiny text-green">
                                          {{ "my-orders.printed" | translate }}
                                        </b>
                                        <div class="d-flex flex-column flex-sm-row gap-sm-2 opacity-50">
                                          <!-- [plotter] -->
                                          <span *ngIf="!order.branchID.is_express" class="zx-text-tiny">
                                            {{ order.print_end | date:'dd/MM/yy' }}
                                          </span>
                                          <!-- [express] -->
                                          <span *ngIf="order.branchID.is_express" class="zx-text-tiny">
                                            {{ order.addedToQueue | date:'dd/MM/yy' }}
                                          </span>
                                          <!-- [plotter] -->
                                          <span *ngIf="!order.branchID.is_express" class="zx-text-tiny">
                                            {{ order.print_end | date:'HH:mm' }}
                                          </span>
                                          <!-- [express] -->
                                          <span *ngIf="order.branchID.is_express" class="zx-text-tiny">
                                            {{ addSecondsToDate(order.addedToQueue, order.files.length) | date:'HH:mm'
                                            }}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- // YES (printed?) -->

                                    <!-- YES (fix products only) -->
                                    <div *ngIf="order.is_only_fix_products_in_order"
                                      class="d-flex justify-content-center zx-status-con-70-p">
                                      <div class="d-flex flex-column">
                                        <b class="zx-text-tiny text-green">
                                          {{ "fix-products.only-fix-products-order" | translate }}
                                        </b>
                                      </div>
                                    </div>
                                    <!-- // YES (sent to print?) -->

                                  </div>
                                </div>
                                <!-- // status and times -->

                              </div>

                              <!-- ERROR row -->
                              <!-- NOT ALL IMAGES HAVE PAPER [whatsup btn] -->
                              <div *ngIf="!isAllFilesHavePaperSet(order)" class="d-flex w-100 py-1 px-2">
                                <div class="d-flex flex-column gap-1 align-items-center">
                                  <b class="text-red zx-text-tiny-tiny zx-text-sm-tiny"
                                    [class.zx-text-white]="isDarkMode">
                                    {{ "my-orders.contact-us-no-paper-on-order" | translate }}
                                  </b>
                                </div>
                              </div>

                            </article>
                          </article>
                        </article>
                      </mat-expansion-panel-header>
                      <!-- // order header -->








                      <!-- SENT order content ============================= SENT order content ============================= SENT order content -->
                      <div class="d-flex flex-column w-100 flex-grow-1">

                        <div class="zx-bg-order px-4 pb-2 d-flex justify-content-between align-items-center">
                          <span class="zx-text-small text-green">
                            <span>{{ "my-orders.order-num" | translate }}</span>
                            <span class="zx-100-opp">-</span>
                            <span>{{ order._id.slice(0, 8) }}</span>
                          </span>
                          <button *ngIf="isSU" mat-flat-button color="secondary"
                            class="rounded-pill zx-text-tiny-tiny zx-text-sm-small text-green"
                            (click)="showUsersOrders(order, true)">
                            {{ "my-profile.go-to-order-many" | translate }}
                          </button>
                          <button *ngIf="isSU" mat-flat-button color="secondary"
                            class="rounded-pill zx-text-tiny-tiny zx-text-sm-small text-green"
                            (click)="showUser(order)">
                            {{ "su-management.users.show-user" | translate }}
                          </button>
                        </div>

                        <!-- files [plotter] ---------- files [plotter] ---------- files [plotter]  -->
                        <div
                          *ngIf="order.branchID && !order.branchID.is_express && order.files && order.files.length > 0"
                          class="d-flex flex-grow-1 w-100 position-relative">
                          <div
                            class="d-flex flex-column align-items-center flex-grow-1 w-100 gap-1 gap-lg-2 overflow-auto p-1 p-lg-2 zx-bg-order rounded-2"
                            [class.zx-choosen-order-action]="
                            order.status !== 'PENDING' && 
                            order.status !== 'QR' &&
                            order.status !== 'NOT_PAID'" [class.zx-border-gray-25-pr]="isDarkMode">
                            <!-- ===== files ===== -->
                            <section
                              ngClass="d-flex w-100 row p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2 gap-2 gap-md-0"
                              [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL"
                              *ngFor="let file of order.files; index as i" class="d-flex w-100">
                              <!-- name - multi page -->
                              <span *ngIf="file.images.length > 1"
                                class="zx-text-small zx-text-pink col-12 w-100 p-0 pb-lg-2 px-lg-2"
                                [class.text-start]="!isRTL" [class.fw-bold]="!isDarkMode"
                                [class.zx-text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
                                <span class="d-sm-none">
                                  <span>
                                    {{file.fileName.split('-')[1] | slice:0:17}}
                                  </span>
                                  <span *ngIf="file.fileName?.split('-')[1]?.length > 17">
                                    ...
                                  </span>
                                  <span class="zx-100-opacity">--</span>
                                  <span class="fw-normal zx-text-tiny text-green">
                                    <span>(</span>
                                    <span>
                                      {{ file.images.length }}
                                    </span>
                                    <span class="zx-text-tiny-tiny">
                                      {{ "printing-table.pages-short" | translate }}
                                    </span>
                                    <span>)</span>
                                  </span>
                                </span>
                                <span class="d-none d-sm-flex">
                                  <span>
                                    {{file.fileName.split('-')[1] | slice:0:40}}
                                  </span>
                                  <span *ngIf="file.fileName?.split('-')[1]?.length > 40">
                                    ...
                                  </span>
                                  <span class="zx-100-opacity">--</span>
                                  <span class="fw-normal text-green">
                                    <span>(</span>
                                    <span>
                                      {{ file.images.length }}
                                    </span>
                                    <span class="zx-text-tiny">
                                      {{ "printing-table.pages-short" | translate }}
                                    </span>
                                    <span>)</span>
                                  </span>
                                </span>
                              </span>
                              <!-- 1st line -->
                              <article *ngFor="let image of file.images; index as j"
                                class="d-flex align-items-center gap-2 gap-lg-3 p-0"
                                [class.zx-border-gray-top-25-pr]="file.images.length > 1"
                                [class.zx-border-gray-left-25-pr-md]="j % 2 === 0 && file.images.length > 1"
                                [class.flex-row-reverse]="!isRTL" [class.col-12]="file.images.length === 1"
                                [class.py-1]="file.images.length > 1" [class.py-lg-2]="file.images.length > 1"
                                [class.ps-md-2]="file.images.length > 1 && j % 2 === 0"
                                [class.pe-md-2]="file.images.length > 1 && j % 2 !== 0"
                                [class.col-12]="file.images.length > 1" [class.col-md-6]="file.images.length > 1">
                                <!-- image -->
                                <article
                                  class="zx-order-summery-image-con d-flex flex-column align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light"
                                  [class.justify-content-between]="order.user !== 'Eazix'"
                                  [class.justify-content-center]="order.user === 'Eazix'">

                                  <!-- -----===----- thumbnail 1/1 [plotter] -----===----- -->
                                  <div class="d-flex zx-medium-plus-icon-size rounded-1" mat-ripple>
                                    <!-- thumbnail 1/1 [plotter] -->
                                    <img (click)="openPreviewDialogInner('plotter',order, file, j)"
                                      *ngIf="!plotterImageErrors[o][i][j]" (error)="plotterImageErrors[o][i][j] = true"
                                      class="w-100 h-100 object-fit-contain c-pointer"
                                      [src]="getImgPlotter(order, i, j)"
                                      [matTooltip]="'printing-table.preview' | translate"
                                      [matTooltipPosition]="'above'">
                                    <!-- error finding image src? -->
                                    <div *ngIf="plotterImageErrors[o][i][j] && order.user !== 'Eazix'"
                                      class="d-flex flex-column align-items-center"
                                      matTooltip="{{ 'my-orders.no-img-src-explain' | translate }}"
                                      matTooltipPosition="below" matTooltipClass="centered-tooltip">
                                      <img class="zx-small-plus-icon-size" src="assets/images/negative-icon.svg">
                                      <b class="zx-text-tiny-tiny text-red text-center zx-lh-tiny-tiny"
                                        [class.zx-text-white]="isDarkMode">
                                        {{ "my-orders.no-img-src" | translate }}
                                      </b>
                                    </div>
                                    <b *ngIf="order.user === 'Eazix'" class="zx-text-tiny-tiny text-green text-center">
                                      {{ "su-management.management-order" | translate }}
                                    </b>
                                    <!-- // error finding image src? -->
                                  </div>
                                  <!-- -----===----- // thumbnail 1/1 [plotter] -----===----- -->

                                  <div *ngIf="order.user !== 'Eazix'"
                                    class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                                    <span class="zx-text-tiny" [class.zx-ltr]="!isRTL">
                                      <span>{{roundDownTowDecimalCeil(image.imageHeight * (2.54 / 300)) }}</span>
                                      <span> × </span>
                                      <span>{{roundDownTowDecimalCeil(image.imageWidth * (2.54 / 300)) }}</span>
                                      <span class="zx-text-tiny-tiny">
                                        {{ "printing-table.dimensions-cm" | translate }}
                                      </span>
                                    </span>
                                  </div>
                                  <article *ngIf="file.images.length > 1" class="position-absolute d-flex w-100 top-0">
                                    <span class="p-1 p-lg-2 zx-bg-light">
                                      <div class="d-flex align-items-center text-green zx-text-tiny"
                                        [class.flex-row-reverse]="isRTL">
                                        <span>
                                          {{ j + 1 }}
                                        </span>
                                        <span>/</span>
                                        <span>
                                          {{ file.images.length }}
                                        </span>
                                      </div>
                                    </span>
                                  </article>
                                  <!-- sentToPrinter or error? [plotter] -->
                                  <div class="d-flex justify-content-end top-0 w-100 position-absolute"
                                    *ngIf="order.addedToQueue">
                                    <mat-icon *ngIf="image.sentToPrinter"
                                      class="zx-text-small text-green zx-text-sm-medium text-center pt-1"
                                      [matTooltip]="'su-management.received-in-printer' | translate"
                                      matTooltipPosition="above">check</mat-icon>
                                    <mat-icon *ngIf="!image.sentToPrinter && !image.errorInSend"
                                      class="zx-text-small text-orange zx-text-sm-medium text-center pt-1"
                                      [matTooltip]="'su-management.no-received-in-printer-yet' | translate"
                                      matTooltipPosition="above">error_outline</mat-icon>
                                    <mat-icon *ngIf="!image.sentToPrinter && image.errorInSend"
                                      class="zx-text-small text-red zx-text-sm-medium text-center pt-1"
                                      [matTooltip]="'su-management.rejected-by-printer' | translate"
                                      matTooltipPosition="above">error</mat-icon>
                                  </div>
                                </article>

                                <!-- file date -->
                                <article class="d-flex flex-column gap-1 gap-sm-2 flex-grow-1">

                                  <!-- [up container] - for more then 1 copy in 1 image files -->
                                  <div class="d-flex d-sm-none w-100"
                                    *ngIf="file.images.length === 1 && image.printSettings.numOfCopies > 1 && file.fileName && file.fileName.length > 0 && file.fileName.includes('-')"
                                    [class.flex-row-reverse]="!isRTL">
                                    <!-- name - single page -->
                                    <span class="zx-text-small zx-text-pink" [class.zx-ltr]="!isRTL"
                                      [class.fw-bold]="!isDarkMode" [class.zx-text-white]="isDarkMode">
                                      <span class="d-sm-none" [class.zx-ltr]="!isRTL">
                                        <span>
                                          {{file.fileName.split('-')[1] | slice:0:12}}
                                        </span>
                                        <span *ngIf="file.fileName?.split('-')[1]?.length > 12">
                                          ...
                                        </span>
                                      </span>
                                      <span class="d-none d-sm-flex" [class.zx-ltr]="!isRTL">
                                        <span>
                                          {{file.fileName.split('-')[1] | slice:0:30}}
                                        </span>
                                        <span *ngIf="file.fileName?.split('-')[1]?.length > 30">
                                          ...
                                        </span>
                                      </span>
                                    </span>
                                  </div>

                                  <!-- [up container] -->
                                  <div class="d-flex w-100 justify-content-between align-items-center"
                                    [class.pb-1]="file.images.length === 1" [class.flex-row-reverse]="!isRTL">
                                    <!-- name placeholder - milti page -->
                                    <span *ngIf="file.images.length > 1" class="zx-100-opacity">-</span>
                                    <!-- name - single page -->
                                    <span
                                      *ngIf="file.images.length === 1 && file.fileName && file.fileName.length > 0 && file.fileName.includes('-')"
                                      class="zx-text-small zx-text-pink" [class.zx-ltr]="!isRTL"
                                      [class.fw-bold]="!isDarkMode" [class.zx-text-white]="isDarkMode">
                                      <span *ngIf="image.printSettings.numOfCopies === 1" class="d-sm-none"
                                        [class.zx-ltr]="!isRTL">
                                        <span>
                                          {{file.fileName.split('-')[1] | slice:0:8}}
                                        </span>
                                        <span *ngIf="file.fileName?.split('-')[1]?.length > 8">
                                          ...
                                        </span>
                                      </span>
                                      <span class="d-none d-sm-flex" [class.zx-ltr]="!isRTL">
                                        <span>
                                          {{file.fileName.split('-')[1] | slice:0:30}}
                                        </span>
                                        <span *ngIf="file.fileName?.split('-')[1]?.length > 30">
                                          ...
                                        </span>
                                      </span>
                                    </span>
                                    <!-- total file price -->
                                    <span *ngIf="image.price" class="px-1 px-lg-3" [class.fw-bold]="!isDarkMode"
                                      [class.zx-ltr]="!isRTL" [class.zx-text-white]="isDarkMode">
                                      <span *ngIf="image.printSettings.numOfCopies > 1" class="zx-text-tiny fw-normal"
                                        [class.zx-ltr]="!isRTL">
                                        <span>
                                          {{
                                          roundDownTowDecimalCeil(
                                          image.price
                                          ) }}
                                        </span>
                                        <span class="zx-text-tiny-tiny">
                                          {{ "printing-table.nis" | translate }}
                                        </span>
                                        <span>×</span>
                                        <span>
                                          {{ image.printSettings.numOfCopies }}
                                        </span>
                                        <span class="zx-text-tiny-tiny">
                                          {{ "printing-table.copies-short" | translate }}
                                        </span>
                                        <span>=</span>
                                      </span>
                                      <span class="zx-text-small">
                                        {{
                                        roundDownTowDecimalCeil(
                                        image.printSettings.numOfCopies *
                                        image.price
                                        )
                                        }}
                                      </span>
                                      <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.nis" | translate }}
                                      </span>
                                    </span>
                                  </div>

                                  <!-- [settings] -->
                                  <div class="d-flex flex-column gap-1 gap-lg-2">
                                    <!-- paper & bw & resize -->
                                    <div class="d-flex gap-1 gap-lg-2 align-items-center"
                                      [class.flex-row-reverse]="!isRTL">
                                      <!-- paper -->
                                      <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <b *ngIf="getPaperSerialNameOrders(image.printSettings.paperType, order.printerID.inputBins)"
                                          class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                                          {{ 'paper-type.name-short.' +
                                          getPaperSerialNameOrders(image.printSettings.paperType,
                                          order.printerID.inputBins)
                                          | translate }}
                                        </b>
                                        <b *ngIf="!getPaperSerialNameOrders(image.printSettings.paperType, order.printerID.inputBins)"
                                          class="zx-text-tiny text-red" [class.zx-text-white]="isDarkMode">
                                          {{ 'printing-table.image-no-paper' | translate }}
                                        </b>
                                      </div>
                                      <!-- bw -->
                                      <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                                          <span *ngIf="!image.printSettings.bw">
                                            {{ "printing-table.color-color" | translate }}
                                          </span>
                                          <span *ngIf="image.printSettings.bw">
                                            {{ "printing-table.color-bandw" | translate }}
                                          </span>
                                        </span>
                                      </div>
                                      <!-- resize -->
                                      <div *ngIf="file.images.length === 1"
                                        class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode"
                                          [class.zx-ltr]="!isRTL">
                                          <span *ngIf="image.scale > 1">
                                            {{ "order-summary-resize-bigger" | translate }}
                                          </span>
                                          <span *ngIf="image.scale < 1">
                                            {{ "order-summary-resize-smaller" | translate }}
                                          </span>
                                          <span *ngIf="image.scale === 1">
                                            {{ "order-summary-resize-original" | translate }}
                                          </span>
                                          <span *ngIf="image.scale && image.scale !== 1" [class.zx-ltr]="!isRTL">
                                            <span *ngIf="isRTL">%</span>
                                            <span>
                                              {{
                                              roundDownTowDecimalCeil(
                                              image.scale * 100
                                              )
                                              }}
                                            </span>
                                            <span *ngIf="!isRTL">%</span>
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                    <!-- center & borders & copies -->
                                    <div class="d-flex gap-1 gap-lg-2 align-items-center"
                                      [class.flex-row-reverse]="!isRTL">
                                      <!-- center -->
                                      <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                                          <span *ngIf="!image.printSettings.centered">
                                            {{ "order-summary-not-centered" | translate }}
                                          </span>
                                          <span *ngIf="image.printSettings.centered">
                                            {{ "order-summary-is-centered" | translate }}
                                          </span>
                                        </span>
                                      </div>
                                      <!-- borders -->
                                      <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                                          <span *ngIf="!image.printSettings.cmFromTop">
                                            {{ "order-summary-not-borders" | translate }}
                                          </span>
                                          <span *ngIf="image.printSettings.cmFromTop">
                                            {{ "order-summary-is-borders" | translate }}
                                          </span>
                                        </span>
                                      </div>
                                      <!-- copies -->
                                      <div *ngIf="image.printSettings.numOfCopies !== 1"
                                        class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                                          <span>{{ image.printSettings.numOfCopies }}</span>
                                          <span>
                                            {{ "printing-table.copies-short" | translate }}
                                          </span>
                                        </span>
                                      </div>
                                    </div>

                                    <!-- resize & doanload-->
                                    <div class="d-flex gap-1 gap-lg-2 align-items-center"
                                      [class.flex-row-reverse]="!isRTL">
                                      <div *ngIf="file.images.length > 1"
                                        class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode"
                                          [class.zx-ltr]="!isRTL">
                                          <span *ngIf="image.scale > 1">
                                            {{ "order-summary-resize-bigger" | translate }}
                                          </span>
                                          <span *ngIf="image.scale < 1">
                                            {{ "order-summary-resize-smaller" | translate }}
                                          </span>
                                          <span *ngIf="image.scale === 1">
                                            {{ "order-summary-resize-original" | translate }}
                                          </span>
                                          <span *ngIf="image.scale !== 1" [class.zx-ltr]="!isRTL">
                                            <span *ngIf="isRTL">%</span>
                                            <span>
                                              {{
                                              roundDownTowDecimalCeil(
                                              image.scale * 100
                                              )
                                              }}
                                            </span>
                                            <span *ngIf="!isRTL">%</span>
                                          </span>
                                        </span>
                                      </div>
                                      <span class="d-flex flex-grow-1"></span>
                                      <div (click)="onDownloadOriginalFile('plotter', j, file, order)"
                                        class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-green-border-gray c-pointer"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny-tiny zx-text-sm-tiny text-green"
                                          [class.zx-text-white]="isDarkMode">
                                          {{ "su-management.users.download" | translate }}
                                        </span>
                                      </div>
                                    </div>

                                  </div>
                                </article>
                                <!-- // file date -->
                              </article>
                              <!-- // 1st line -->
                            </section>
                            <!-- // ===== files ===== -->

                          </div>
                        </div>
                        <!-- // files [plotter] ---------- files [plotter] ---------- files [plotter]  -->








                        <!-- files [express] ---------- files [express] ---------- files [express]  -->
                        <div *ngIf="order.branchID && order.branchID.is_express"
                          class="d-flex flex-grow-1 w-100 position-relative">
                          <div
                            class="d-flex flex-column align-items-center flex-grow-1 w-100 gap-1 gap-lg-2 overflow-auto p-1 p-lg-2 zx-bg-order rounded-2"
                            [class.zx-choosen-order-action]="
                            order.status !== 'PENDING' && 
                            order.status !== 'QR' &&
                            order.status !== 'NOT_PAID'" [class.zx-border-gray-25-pr]="isDarkMode">
                            <!-- ===== files ===== -->
                            <section
                              ngClass="w-100 flex-column p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2"
                              [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL"
                              *ngFor="let file of order.files; index as i" class="d-flex w-100">
                              <!-- 1st line -->
                              <article class="d-flex align-items-center gap-2 gap-lg-3 w-100"
                                [class.flex-row-reverse]="!isRTL">
                                <!-- first image -->
                                <article
                                  class="zx-order-summery-image-con d-flex flex-column justify-content-between align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">

                                  <!-- -----===----- thumbnail 1/2 [express] -----===----- -->
                                  <div class="d-flex zx-medium-plus-icon-size rounded-1" mat-ripple>
                                    <!-- thumbnail 1/2 [express] -->
                                    <img *ngIf="!expressImageErrors1[o][i][0]"
                                      (error)="expressImageErrors1[o][i][0] = true"
                                      (click)="openPreviewDialogInner('express',order, file, 0)"
                                      class="w-100 h-100 object-fit-contain c-pointer"
                                      [src]="getImgExpress(order, file.images[0].thumbnailPath)" alt="File Page Image"
                                      [matTooltip]="'printing-table.preview' | translate"
                                      [matTooltipPosition]="'above'">
                                    <!-- error finding image src? -->
                                    <div *ngIf="expressImageErrors1[o][i][0]"
                                      class="d-flex flex-column align-items-center"
                                      matTooltip="{{ 'my-orders.no-img-src-explain' | translate }}"
                                      matTooltipPosition="below" matTooltipClass="centered-tooltip">
                                      <img class="zx-small-plus-icon-size" src="assets/images/negative-icon.svg">
                                      <b class="zx-text-tiny-tiny text-red text-center zx-lh-tiny-tiny"
                                        [class.zx-text-white]="isDarkMode">
                                        {{ "my-orders.no-img-src" | translate }}
                                      </b>
                                    </div>
                                    <!-- // error finding image src? -->
                                  </div>
                                  <!-- -----===----- // thumbnail 1/2 [express] -----===----- -->

                                  <div class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                                    <span class="zx-text-tiny" [class.zx-ltr]="!isRTL">
                                      <span>
                                        {{
                                        getExpressDimensions('h', file.images[0].imageHeight, file.images[0].imageWidth,
                                        file.printSettings, order.printerID.consumables.papers,
                                        file.images[0].origImageDPI)
                                        }}
                                      </span>
                                      <span>×</span>
                                      <span>
                                        {{
                                        getExpressDimensions('w', file.images[0].imageHeight, file.images[0].imageWidth,
                                        file.printSettings, order.printerID.consumables.papers,
                                        file.images[0].origImageDPI)
                                        }}
                                      </span>
                                      <span class="zx-text-tiny-tiny">
                                        {{ "printing-table.dimensions-cm" | translate }}
                                      </span>
                                    </span>
                                  </div>
                                  <article *ngIf="file.images.length > 1" class="position-absolute d-flex w-100 top-0"
                                    [class.flex-row-reverse]="!isRTL">
                                    <span class="p-1 p-lg-2 zx-bg-light">
                                      <div class="d-flex align-items-center text-green zx-text-tiny"
                                        [class.flex-row-reverse]="isRTL">
                                        <span>1</span>
                                        <span>/</span>
                                        <span>
                                          {{ file.images.length }}
                                        </span>
                                      </div>
                                    </span>
                                  </article>
                                  <!-- sentToPrinter or error? [express] -->
                                  <div class="d-flex justify-content-end top-0 w-100 position-absolute"
                                    *ngIf="order.addedToQueue">
                                    <mat-icon *ngIf="!file.error && (file.sentToPrinter || file.remote_id)"
                                      class="zx-text-small text-green zx-text-sm-medium text-center pt-1"
                                      [matTooltip]="'su-management.received-in-printer' | translate"
                                      matTooltipPosition="above">check</mat-icon>
                                    <mat-icon *ngIf="!file.error && !(file.sentToPrinter || file.remote_id)"
                                      class="zx-text-small text-orange zx-text-sm-medium text-center pt-1"
                                      [matTooltip]="'su-management.no-received-in-printer-yet' | translate"
                                      matTooltipPosition="above">error_outline</mat-icon>
                                    <mat-icon *ngIf="file.error"
                                      class="zx-text-small text-red zx-text-sm-medium text-center pt-1"
                                      [matTooltip]="'su-management.rejected-by-printer' | translate"
                                      matTooltipPosition="above">error</mat-icon>
                                  </div>
                                </article>
                                <!-- file date -->
                                <article class="d-flex flex-column gap-1 gap-sm-2 flex-grow-1">

                                  <!-- [up container] -->
                                  <div class="d-flex w-100 justify-content-between align-items-center pb-1"
                                    [class.flex-row-reverse]="!isRTL">
                                    <!-- name -->
                                    <span class="zx-text-small zx-text-pink" [class.fw-bold]="!isDarkMode"
                                      [class.zx-text-white]="isDarkMode">
                                      <span class="d-sm-none">
                                        <span>
                                          {{file.fileName.split('-')[1] | slice:0:17}}
                                        </span>
                                        <span *ngIf="file.fileName?.split('-')[1]?.length > 17">
                                          ...
                                        </span>
                                      </span>
                                      <span class="d-none d-sm-flex">
                                        <span>
                                          {{file.fileName.split('-')[1] | slice:0:40}}
                                        </span>
                                        <span *ngIf="file.fileName?.split('-')[1]?.length > 40">
                                          ...
                                        </span>
                                      </span>
                                    </span>
                                    <!-- total file price -->
                                    <span class="px-1 px-lg-3" [class.fw-bold]="!isDarkMode"
                                      [class.zx-text-white]="isDarkMode">
                                      <span class="zx-text-small">
                                        {{ roundDownTowDecimalCeil(file.price) }}
                                      </span>
                                      <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.nis" | translate }}
                                      </span>
                                    </span>
                                  </div>

                                  <!-- [settings] -->
                                  <div class="d-flex flex-column gap-1 gap-lg-2" [class.flex-sm-row]="isRTL"
                                    [class.flex-sm-row-reverse]="!isRTL">
                                    <!-- paper & bw & copies-->
                                    <div class="d-flex gap-1 gap-lg-2 align-items-center"
                                      [class.flex-row-reverse]="!isRTL">
                                      <!-- paper -->
                                      <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <b *ngIf="getPaperSerialNameOrdersExpress(file.printSettings.paperType, order.printerID.consumables.papers)"
                                          class="zx-text-tiny zx-text-sm-small text-center"
                                          [class.zx-text-white]="isDarkMode">
                                          {{ 'paper-type.name-short.' +
                                          getPaperSerialNameOrdersExpress(file.printSettings.paperType,
                                          order.printerID.consumables.papers)
                                          | translate }}
                                        </b>
                                        <b *ngIf="!getPaperSerialNameOrdersExpress(file.printSettings.paperType, order.printerID.consumables.papers)"
                                          class="zx-text-tiny zx-text-sm-small text-red text-center"
                                          [class.zx-text-white]="isDarkMode">
                                          {{ 'printing-table.image-no-paper' | translate }}
                                        </b>
                                      </div>
                                      <!-- bw -->
                                      <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny zx-text-sm-small text-center"
                                          [class.zx-text-white]="isDarkMode">
                                          <span *ngIf="!file.printSettings.bw">
                                            {{ "printing-table.color-color" | translate }}
                                          </span>
                                          <span *ngIf="file.printSettings.bw">
                                            {{ "printing-table.color-bandw" | translate }}
                                          </span>
                                        </span>
                                      </div>
                                      <!-- copies -->
                                      <div *ngIf="file.printSettings.numOfCopies !== 1"
                                        class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny" [class.zx-text-white]="isDarkMode">
                                          <span>{{ file.printSettings.numOfCopies }}</span>
                                          <span>
                                            {{ "printing-table.copies-short" | translate }}
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                    <!-- doubleSided & fit -->
                                    <div class="d-flex gap-1 gap-lg-2 align-items-center"
                                      [class.flex-row-reverse]="!isRTL">
                                      <!-- doubleSided -->
                                      <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny zx-text-sm-small text-center"
                                          [class.zx-text-white]="isDarkMode">
                                          <span *ngIf="!file.printSettings.doubleSided">
                                            {{ "printing-table.sides-one" | translate }}
                                          </span>
                                          <span *ngIf="file.printSettings.doubleSided">
                                            {{ "printing-table.sides-two" | translate }}
                                          </span>
                                        </span>
                                      </div>
                                      <!-- fit -->
                                      <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny zx-text-sm-small text-center"
                                          [class.zx-text-white]="isDarkMode">
                                          <span *ngIf="!file.printSettings.fit && !file.printSettings.cropRatio">
                                            {{ "order-summary-resize-original" | translate }}
                                          </span>
                                          <span *ngIf="file.printSettings.fit && !file.printSettings.cropRatio">
                                            {{ "order-summary-resize-maximal" | translate }}
                                          </span>
                                          <span *ngIf="file.printSettings.cropRatio">
                                            {{ "order-summary-resize-crop" | translate }}
                                          </span>
                                        </span>
                                      </div>
                                      <!-- isMerged - for maniger -->
                                      <div *ngIf="file.isMerged"
                                        class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <span class="zx-text-tiny zx-text-sm-small text-center zx-text-pink"
                                          [class.zx-text-white]="isDarkMode">
                                          <span>
                                            {{ "my-orders.merged-file" | translate }}
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <!-- [down container] -->
                                  <!-- calc file price -->
                                  <span *ngIf="file.images?.length > 1 && file.printSettings?.numOfCopies > 1"
                                    [class.text-start]="!isRTL" [class.zx-text-white]="isDarkMode"
                                    [class.zx-ltr]="!isRTL">
                                    <div *ngIf="file.images.length > 1 || file.printSettings?.numOfCopies > 1"
                                      class="d-flex gap-1 gap-lg-2 align-items-center"
                                      [class.flex-row-reverse]="!isRTL">
                                      <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                                        [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                        <!-- pages -->
                                        <span *ngIf="file.images?.length > 1">
                                          <span class="zx-text-tiny zx-text-sm-small text-center">
                                            {{
                                            file.images.length
                                            }}
                                          </span>
                                          <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                            {{ "printing-table.pages-short" | translate }}
                                          </span>
                                        </span>
                                        <!-- , -->
                                        <span *ngIf="file.images?.length > 1 && file.printSettings?.numOfCopies > 1">
                                          <!-- <span class="zx-100-opacity">_</span> -->
                                          <span class="zx-text-tiny-tiny zx-text-sm-tiny">, </span>
                                        </span>
                                        <span *ngIf="file.printSettings?.numOfCopies > 1">
                                          <!-- copies -->
                                          <span class="zx-text-tiny zx-text-sm-small text-center">
                                            {{
                                            file.printSettings?.numOfCopies
                                            }}
                                          </span>
                                          <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                            {{ "printing-table.copies-short" | translate }}
                                          </span>
                                          <!-- , -->
                                          <span class="zx-text-tiny-tiny zx-text-sm-tiny">, </span>
                                          <!-- price per page -->
                                          <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                            {{ "printing-table.price-per-copy" | translate }}
                                          </span>
                                          <span class="zx-text-tiny-tiny zx-text-sm-tiny">:</span>
                                          <span class="zx-text-tiny zx-text-sm-small text-center">
                                            {{
                                            roundDownTowDecimalCeil(
                                            file.price /
                                            file.printSettings?.numOfCopies)
                                            }}
                                          </span>
                                          <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                            {{ "printing-table.nis" | translate }}
                                          </span>
                                        </span>
                                        <span class="zx-100-opacity">_</span>
                                      </div>
                                    </div>
                                  </span>

                                  <div class="w-100 d-flex justify-content-end">
                                    <div (click)="onDownloadOriginalFile('express',0, file, order)"
                                      class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill text-center zx-bg-green-border-gray c-pointer"
                                      [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                                      <span class="zx-text-tiny-tiny zx-text-sm-tiny text-green"
                                        [class.zx-text-white]="isDarkMode">
                                        {{ "su-management.users.download" | translate }}
                                      </span>
                                    </div>
                                  </div>
                                </article>
                                <!-- // file date -->
                              </article>
                              <!-- // 1st line -->

                              <!-- 2nd line -->
                              <article *ngIf="file.images.length > 1" class="d-flex row w-100 pt-1"
                                [class.zx-ltr]="!isRTL">
                                <article *ngFor="let image of file.images; let j = index"
                                  [class.d-flex]="!(j === 0 || (!isAllImagesShowen && j > 12)) || (file.images.length === 14 && j === 13)"
                                  [class.d-none]="(j === 0 || (!isAllImagesShowen && j > 12)) && !(file.images.length === 14 && j === 13)"
                                  class="col-4 col-sm-3 col-md-2 pb-1" style="max-width: max-content;">
                                  <!-- 2 + image -->
                                  <article
                                    class="zx-order-summery-image-con d-flex flex-column justify-content-between align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">

                                    <!-- -----===----- thumbnail 2/2 [express] -----===----- -->
                                    <div class="d-flex zx-medium-plus-icon-size rounded-1" mat-ripple>
                                      <!-- thumbnail 2/2 [express] -->
                                      <img *ngIf="!expressImageErrors2[o][i][j]"
                                        (error)="expressImageErrors2[o][i][j] = true"
                                        (click)="openPreviewDialogInner('express',order, file, j)"
                                        class="w-100 h-100 object-fit-contain c-pointer"
                                        [src]="getImgExpress(order, file.images[j].thumbnailPath)"
                                        [matTooltip]="'printing-table.preview' | translate"
                                        [matTooltipPosition]="'above'" alt="File Page Image">
                                      <!-- error finding image src? -->
                                      <div *ngIf="expressImageErrors2[o][i][j]"
                                        class="d-flex flex-column align-items-center"
                                        matTooltip="{{ 'my-orders.no-img-src-explain' | translate }}"
                                        matTooltipPosition="below" matTooltipClass="centered-tooltip">
                                        <img class="zx-small-plus-icon-size" src="assets/images/negative-icon.svg">
                                        <b class="zx-text-tiny-tiny text-red text-center zx-lh-tiny-tiny"
                                          [class.zx-text-white]="isDarkMode">
                                          {{ "my-orders.no-img-src" | translate }}
                                        </b>
                                      </div>
                                      <!-- // error finding image src? -->
                                    </div>
                                    <!-- -----===----- // thumbnail 2/2 [express] -----===----- -->

                                    <div class="d-flex w-100 align-items-center justify-content-center pt-1 pt-lg-2">
                                      <span class="zx-text-tiny">
                                        <span>
                                          {{
                                          getExpressDimensions('h', file.images[j].imageHeight,
                                          file.images[j].imageWidth,
                                          file.printSettings, order.printerID.consumables.papers,
                                          file.images[j].origImageDPI)
                                          }}
                                        </span>
                                        <span>×</span>
                                        <span>
                                          {{
                                          getExpressDimensions('w', file.images[j].imageHeight,
                                          file.images[j].imageWidth,
                                          file.printSettings, order.printerID.consumables.papers,
                                          file.images[j].origImageDPI)
                                          }}
                                        </span>
                                        <span class="zx-text-tiny-tiny">
                                          {{ "printing-table.dimensions-cm" | translate }}
                                        </span>
                                      </span>
                                    </div>
                                    <article class="position-absolute d-flex w-100 top-0">
                                      <span class="p-1 p-lg-2 zx-bg-light">
                                        <div class="d-flex align-items-center text-green zx-text-tiny"
                                          [class.flex-row-reverse]="isRTL">
                                          <span>
                                            {{j + 1}}
                                          </span>
                                          <span>/</span>
                                          <span>
                                            {{file.images.length}}
                                          </span>
                                        </div>
                                      </span>
                                    </article>
                                  </article>
                                  <!-- // 2 + image -->
                                </article>
                                <!-- BTN - SHOWW more images... -->
                                <article *ngIf="!isAllImagesShowen && file.images.length > 14"
                                  class="col-4 col-sm-3 col-md-2 pb-1 c-pointer" style="max-width: max-content;"
                                  (click)="showMoreImages()">
                                  <article mat-ripple
                                    class="zx-order-summery-image-con d-flex flex-column gap-1 align-items-center justify-content-center p-1 p-lg-2 c-pointer rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light step-item-hover">
                                    <span class="zx-text-tiny text-center text-green c-pointer"
                                      style="max-width: 90px;">
                                      <b>
                                        {{ "my-orders.show" | translate }}
                                      </b>
                                      <b>
                                        {{ file.images.length - 13 }}
                                      </b>
                                    </span>
                                    <b class="zx-text-tiny text-center text-green c-pointer">
                                      {{ "my-orders.more-pages" | translate }}
                                    </b>
                                  </article>
                                </article>
                                <!-- BTN - HIDE more images... -->
                                <article *ngIf="isAllImagesShowen && file.images.length > 14"
                                  class="col-4 col-sm-3 col-md-2 pb-1 c-pointer" style="max-width: max-content;"
                                  (click)="hideMoreImages()">
                                  <article mat-ripple
                                    class="zx-order-summery-image-con d-flex flex-column gap-1 align-items-center justify-content-center p-1 p-lg-2 c-pointer rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light step-item-hover">
                                    <span class="zx-text-tiny text-center text-green c-pointer"
                                      style="max-width: 90px;">
                                      <b>
                                        {{ "my-orders.hide" | translate }}
                                      </b>
                                      <b>
                                        {{ file.images.length - 13 }}
                                      </b>
                                    </span>
                                    <b class="zx-text-tiny text-center text-green c-pointer">
                                      {{ "my-orders.more-pages" | translate }}
                                    </b>
                                  </article>
                                </article>
                              </article>
                              <!-- // 2nd line -->

                            </section>
                            <!-- // ===== files ===== -->

                            <!-- ===== fix products ===== -->
                            <section
                              ngClass="w-100 flex-column p-2 zx-border-gray-v-v-light zx-bg-light shadow-85 rounded-2"
                              [class.zx-bg-dark-no-border]="isDarkMode" [class.align-items-end]="!isRTL"
                              *ngFor="let product of order.fix_products_order?.products; index as i"
                              class="d-flex w-100">
                              <!-- 1st line -->
                              <article class="d-flex align-items-center gap-2 gap-lg-3 w-100"
                                [class.flex-row-reverse]="!isRTL">
                                <!-- product image -->
                                <article
                                  class="zx-order-summery-image-con d-flex flex-column justify-content-center align-items-center position-relative p-1 p-lg-2 rounded-1 bg-white zx-border-gray-v-v-light shadow-85-light">
                                  <img class="object-fit-contain zx-big-minus-icon-size"
                                    [src]="'assets/images/fix-products/' + product.productId.previewImage + '.png'"
                                    alt="Product Image">
                                </article>
                                <!-- product date -->
                                <article class="d-flex flex-column gap-1 gap-sm-2 flex-grow-1">

                                  <!-- [up container] -->
                                  <div class="d-flex w-100 justify-content-between align-items-center pb-1"
                                    [class.flex-row-reverse]="!isRTL">
                                    <!-- name -->
                                    <span class="zx-text-small zx-text-pink" [class.fw-bold]="!isDarkMode"
                                      [class.zx-text-white]="isDarkMode">
                                      <span>
                                        <span>
                                          {{ "fix-product." + product.productId.name | translate }}
                                        </span>
                                      </span>
                                    </span>
                                    <!-- total product price -->
                                    <span class="px-1 px-lg-3" [class.fw-bold]="!isDarkMode"
                                      [class.zx-text-white]="isDarkMode">
                                      <span class="zx-text-small">
                                        {{ product.price ? product.price * product.quantity :
                                        product.productId.defaultPrice * product.quantity }}
                                      </span>
                                      <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                        {{ "printing-table.nis" | translate }}
                                      </span>
                                    </span>
                                  </div>

                                  <!-- [settings] -->
                                  <div class="d-flex">
                                    <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray flex-shrink-1"
                                      [class.flex-sm-row]="isRTL" [class.flex-sm-row-reverse]="!isRTL">
                                      <!-- one -->
                                      <span *ngIf="product.quantity === 1"
                                        class="zx-text-tiny zx-text-sm-small d-flex align-items-end">
                                        <span>
                                          {{ "su-management.units.one" | translate }}
                                        </span>
                                      </span>
                                      <!-- many -->
                                      <span *ngIf="product.quantity > 1"
                                        class="zx-text-tiny zx-text-sm-small d-flex align-items-end">
                                        <span>{{ product.price ? product.price : product.productId.defaultPrice
                                          }}</span>
                                        <span class="zx-100-opp">.</span>
                                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                          {{ "printing-table.nis" | translate }}
                                        </span>
                                        <span class="zx-100-opp">.</span>
                                        <span>×</span>
                                        <span class="zx-100-opp">.</span>
                                        <span>{{ product.quantity }}</span>
                                        <span class="zx-100-opp">.</span>
                                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                          {{ "su-management.units.short" | translate }}
                                        </span>
                                        <span class="zx-100-opp">.</span>
                                        <span>=</span>
                                        <span class="zx-100-opp">.</span>
                                        <span>{{ (product.price ? product.price : product.productId.defaultPrice) *
                                          product.quantity }}</span>
                                        <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                          {{ "printing-table.nis" | translate }}
                                        </span>
                                      </span>
                                    </div>
                                  </div>

                                  <span class="zx-100-opacity">_</span>
                                  <span class="zx-100-opacity d-sm-none">_</span>

                                </article>
                                <!-- // product date -->
                              </article>
                              <!-- // 1st line -->

                            </section>
                            <!-- // ===== fix products ===== -->

                          </div>
                        </div>
                        <!-- // files [express] ---------- files [express] ---------- files [express]  -->

                      </div>
                      <!-- // SENT order content ============================= SENT order content ============================= SENT order content -->







                      <mat-action-row *ngIf="(
                        order.status === 'PENDING' || 
                        order.status === 'QR' ||
                        order.status === 'NOT_PAID')"
                        class="align-items-center justify-content-center d-flex zx-choosen-order-action">
                        <!-- NO, BUT POSSIBLE! (sent to print?) -->
                        <div *ngIf="order.files && order.files.length > 0">
                          <button class="rounded-pill" color="primary" mat-raised-button [disabled]="!isSU">
                            <b class="zx-text-tiny zx-text-sm-small px-3 px-lg-5">
                              <span class="text-white">{{ "my-orders.send-to-print-this-order-1" | translate }}</span>
                              <span class="zx-100-opp">-</span>
                              <span class="text-white">{{ order._id.slice(0, 8) }}</span>
                              <span class="zx-100-opp d-none d-sm-inline">-</span>
                              <span class="text-white d-none d-sm-inline">{{ "my-orders.send-to-print-this-order-2" |
                                translate }}</span>
                            </b>
                          </button>
                        </div>
                        <!-- NO, BUT NOT POSSIBLE! NO FILES! (sent to print?) -->
                        <div *ngIf="!order.files || order.files.length === 0"
                          class="d-flex w-100 flex-column flex-lg-row gap-2 gap-lg-0 align-items-center justify-content-lg-between">
                          <b class="text-red zx-text-tiny px-lg-3" [class.zx-text-white]="isDarkMode">
                            {{'my-orders.contact-us-no-files-order' | translate}}
                          </b>
                          <b class="text-green zx-text-tiny px-lg-3">
                            {{'my-orders.contact-us-for-help-explain' | translate}}
                          </b>
                        </div>
                      </mat-action-row>
                    </mat-expansion-panel>

                  </mat-accordion>
                  <!-- // orders accordion -->

                  <!-- NO orders -->
                  <div *ngIf="orders.length <= 0 && !isLoading"
                    class="d-flex flex-column align-items-center justify-content-center gap-1 gap-sm-2 flex-grow-1">
                    <mat-spinner class="zx-small-plus-icon-size zx-medium-icon-size-lg"></mat-spinner>
                  </div>
                  <!-- // NO orders -->

                  <span class="d-flex" style="min-height: 20px;"></span>

                </section>
                <!-- // orders -------------------------------------------------------------------------------------------------------- // orders -->
              </div>

              <!-- <div class="d-flex flex-column" *ngIf="!(orders.length <= 0 && !isLoading)">
                <mat-paginator class="m-0" [length]="totalOrders" [pageSize]="ordersPerPage"
                  [pageSizeOptions]="pageSizeOptions" (page)="onChangedPageOrders($event)"
                  *ngIf="orders.length > 0"></mat-paginator>
              </div> -->
            </div>
          </div>
        </div>
        <!-- // content -->
      </mat-tab>
      <!-- // ===== ===== ===== ===== ===== ===== orders ===== ===== ===== ===== ===== ===== -->

















































      <!-- ===== ===== ===== ===== ===== ===== users ===== ===== ===== ===== ===== ===== -->
      <mat-tab [disabled]="!isSU || isLoadingTabChange" class="w-100 d-flex flex-grow-1 flex-column" label="users">
        <ng-template mat-tab-label>
          <div class="d-flex flex-column flex-lg-row-reverse align-items-center justify-content-center gap-1 gap-lg-2">
            <b class="zx-text-tiny-tiny zx-text-sm-small">
              {{ 'su-management.users-management.short' | translate }}
            </b>
            <mat-icon>supervisor_account</mat-icon>
          </div>
        </ng-template>
        <!-- content -->
        <div class="w-100 d-flex h-100 flex-column">
          <div class="w-100 d-flex flex-grow-1 flex-column py-3 px-lg-5">

            <!-- --------------- title --------------- -->
            <div class="w-100 d-flex justify-content-center px-3">
              <div class="w-100 d-flex justify-content-center zx-border-bottom-green-bold mb-4 pb-2 px-3 px-lg-5">
                <h6 class="fw-bold zx-text-medium zx-text-sm-big" [class.text-green]="!isDarkMode">
                  {{ 'su-management.users-management' | translate }}
                </h6>
              </div>
            </div>
            <!-- // --------------- title --------------- -->

            <!-- search -->
            <div class="search-container p-2 pb-3">
              <input type="text" class="form-control" [placeholder]="usersSearchPlaceholder"
                [(ngModel)]="userSearchText" (ngModelChange)="filterUsers()">
            </div>

            <!-- LOADING... users -->
            <div *ngIf="!(subPage === 'users' && !isLoading && !isLoadUsers)"
              class="w-100 d-flex justify-content-center align-items-center px-xl-5 py-5 flex-grow-1">
              <mat-spinner class="zx-medium-icon-size zx-medium-big-icon-size-lg"></mat-spinner>
            </div>

            <!-- finished LOADING... NO users -->
            <div *ngIf="users?.length === 0 && (subPage === 'users' && !isLoading && !isLoadUsers)"
              class="fill-height px-2 pb-2 d-flex justify-content-center align-items-center flex-grow-1">
              <span>
                {{ 'su-management.users.users-not-found' | translate }}
              </span>
            </div>

            <!-- finished LOADING... users -->
            <div *ngIf="subPage === 'users' && users?.length > 0 && !isLoading && !isLoadUsers"
              class="fill-height px-2 pb-2 d-flex px-xl-5">

              <!-- users -------------------------------------------------------------------------------------------------------- users -->
              <section class="w-100 d-flex flex-column">
                <!-- users accordion -->
                <mat-accordion #scrollContainerUsers class="w-100 pb-3" multi="false"
                  *ngIf="users.length > 0 && !isLoading">

                  <mat-expansion-panel *ngFor="let user of users; index as i"
                    [expanded]="user.user._id === expandedPanelIdUsers" [attr.data-user-id]="user.user._id">
                    <mat-expansion-panel-header (click)="togglePanelUsers(user.user)"
                      [class.zx-choosen-order]="expandedPanelIdUsers === user.user._id">
                      <article class="w-100 d-flex flex-column gap-2">

                        <!-- === USER HEADER DATA LINE === -->
                        <article class="w-100 row d-flex">
                          <!-- displayName -->
                          <div class="col-6 col-xl-3 d-flex flex-column gap-1">
                            <span class="zx-text-tiny-tiny opacity-75 p-0">
                              {{ 's-screen.plotter-que.title.username' | translate }}
                            </span>
                            <span class="zx-text-small zx-text-sm-medium d-sm-none">
                              <span *ngIf="!(user.user.displayName.length > 12)">
                                {{ user.user.displayName }}
                              </span>
                              <span *ngIf="user.user.displayName.length > 12">
                                <span>
                                  {{ user.user.displayName | slice:0:12 }}
                                </span>
                                <span>
                                  ...
                                </span>
                              </span>
                            </span>
                            <span class="zx-text-small zx-text-sm-medium d-none d-sm-inline">
                              <span *ngIf="!(user.user.displayName.length > 25)">
                                {{ user.user.displayName }}
                              </span>
                              <span *ngIf="user.user.displayName.length > 25">
                                <span>
                                  {{ user.user.displayName | slice:0:25 }}
                                </span>
                                <span>
                                  ..
                                </span>
                              </span>
                            </span>
                          </div>
                          <!-- // displayName -->

                          <!-- email -->
                          <div class="col-6 col-xl-3 d-flex flex-column gap-1">
                            <span class="zx-text-tiny-tiny opacity-75 p-0">
                              {{ 'su-management.branches_email' | translate }}
                            </span>
                            <div class="d-flex align-items-center gap-1 gap-md-2">
                              <span class="zx-text-small zx-text-sm-medium d-sm-none">
                                <span *ngIf="user.user.email && user.user.email.length <= 10">
                                  {{ user.user.email }}
                                </span>
                                <span *ngIf="user.user.email && user.user.email.length > 10">
                                  <span>
                                    {{ user.user.email | slice:0:10 }}
                                  </span>
                                  <span>
                                    ...
                                  </span>
                                </span>
                              </span>
                              <span class="zx-text-small zx-text-sm-medium d-none d-sm-inline">
                                <span *ngIf="user.user.email && user.user.email.length <= 25">
                                  {{ user.user.email }}
                                </span>
                                <span *ngIf="user.user.email && user.user.email.length > 25">
                                  <span>
                                    {{ user.user.email | slice:0:25 }}
                                  </span>
                                  <span>
                                    ...
                                  </span>
                                </span>
                              </span>
                              <mat-icon
                                class="zx-text-small text-green-vivid-mid-hover c-pointer zx-small-tiny-plus-icon-size opacity-75"
                                (click)="copyOrderOneDetail('email', user.user.email); $event.stopPropagation()">content_copy</mat-icon>
                            </div>
                          </div>
                          <!-- // email -->

                          <!-- phone -->
                          <div class="col-6 col-xl-3 d-flex flex-column gap-1 pt-1 pt-md-0">
                            <span class="zx-text-tiny-tiny opacity-75 p-0">
                              {{ 'su-management.branches_phone' | translate }}
                            </span>
                            <div class="d-flex align-items-center gap-1 gap-md-2">
                              <span *ngIf="user.user.phone" class="zx-text-small zx-text-sm-medium">
                                {{ formatPhone(user.user.phone) }}
                              </span>
                              <span *ngIf="!user.user.phone" class="zx-text-tiny opacity-75 p-0">
                                {{ 'su-management.not-existing' | translate }}
                              </span>
                              <mat-icon *ngIf="user.user?.phone && user.user?.phone !== ''"
                                class="zx-text-small text-green-vivid-mid-hover c-pointer zx-small-tiny-plus-icon-size opacity-75"
                                (click)="copyOrderOneDetail('phone', user.user.phone); $event.stopPropagation()">content_copy</mat-icon>
                            </div>
                          </div>
                          <!-- // phone -->

                          <!-- last visit (place) -->
                          <div class="col-6 col-xl-3 d-flex flex-column gap-1 pt-1">
                            <span class="zx-text-tiny-tiny opacity-75 p-0">
                              {{ 'su-management.last-place' | translate }}
                            </span>
                            <span
                              *ngIf="user.user.home_printingServices_list[0].length > 0 && user.user.home_branches_list[0].length > 0"
                              class="d-flex align-items-center gap-1 gap-sm-2 zx-text-tiny zx-text-sm-small">
                              <img [src]="'assets/images/branches/' + user.user.home_branches_list[0] + '.png'"
                                alt="Branchs Logo" class="zx-small-icon-size">
                              <span>
                                <span
                                  *ngIf="!(('choose-branch.naming.' + user.user.home_branches_list[0] | translate).length > 14)">
                                  {{ "choose-branch.naming." + user.user.home_printingServices_list[0] + "." +
                                  user.user.home_branches_list[0] | translate }}
                                </span>
                                <span
                                  *ngIf="('choose-branch.naming.' + user.user.home_branches_list[0] | translate).length > 14">
                                  <span>
                                    {{ ("choose-branch.naming." + user.user.home_printingServices_list[0] + '.' +
                                    user.user.home_branches_list[0] | translate |
                                    slice:0:14) }}
                                  </span>
                                  <span>
                                    ...
                                  </span>
                                </span>
                              </span>
                            </span>
                            <span
                              *ngIf="!(user.user.home_printingServices_list[0].length > 0 && user.user.home_branches_list[0].length > 0)"
                              class="zx-text-tiny opacity-75 p-0">
                              {{ 'su-management.last-place.no-places' | translate }}
                            </span>
                          </div>
                          <!-- // last visit (place) -->

                        </article>
                      </article>
                      <!-- // === USER HEADER DATA LINE === -->

                    </mat-expansion-panel-header>

                    <!-- === USER CONTENT DATA LINE === -->
                    <div
                      class="d-flex flex-column gap-1 w-100 flex-grow-1 zx-choosen-order-action zx-px-24-px pb-2 pb-lg-3">

                      <!-- === MAIN DATA CONTAINER === -->
                      <article class="w-100 row d-flex">

                        <!-- provider -->
                        <div class="col-6 col-lg-3 d-flex flex-column gap-1 pt-1">
                          <span class="zx-text-tiny-tiny opacity-75 p-0">
                            {{ 'my-profile.probider' | translate }}
                          </span>
                          <div *ngIf="user.user.provider" class="d-flex w-100 align-items-center gap-2 pb-3">
                            <!-- google -->
                            <div *ngIf="user.user.provider === 'google'" class="d-flex align-items-center gap-2">
                              <span class="zx-text-small zx-text-sm-medium">
                                Google
                              </span>
                              <img class="zx-small-icon-size" src="../../../assets/images/google-icon.svg"
                                alt="Google Logo">
                            </div>
                            <!-- Facebook -->
                            <div *ngIf="user.user.provider === 'facebook'" class="d-flex align-items-center gap-2">
                              <span class="zx-text-small zx-text-sm-medium">
                                Facebook
                              </span>
                              <img class="zx-small-icon-size" src="../../../assets/images/fb-icon.svg"
                                alt="Facebook Logo">
                            </div>
                            <!-- eazix (local) -->
                            <div *ngIf="user.user.provider !== 'google' && user.user.provider !== 'facebook'"
                              class="d-flex align-items-center gap-2">
                              <span class="zx-text-small zx-text-sm-medium">
                                {{ "my-profile.probider-local" | translate }}
                              </span>
                              <img class="zx-small-icon-size" src="assets/images/eazix-logo-small.svg" alt="Eazix Logo">
                            </div>
                          </div>
                        </div>
                        <!-- // provider -->

                        <!-- created -->
                        <div class="col-6 col-lg-3 d-flex flex-column gap-1 pt-1">
                          <span class="zx-text-tiny-tiny opacity-75 p-0">
                            {{ "my-profile.created" | translate }}
                          </span>
                          <span class="zx-text-small zx-text-sm-medium opacity-75 p-0 d-flex flex-column gap-1">
                            <!-- date -->
                            <span>
                              {{ user.user.created | date:'dd/MM/yy' }}
                            </span>
                            <span>
                              <span>
                                {{ "my-orders.at" | translate }}
                              </span>
                              <span class="zx-100-opp">-</span>
                              <span>
                                {{ user.user.created | date:'HH:mm' }}
                              </span>
                            </span>
                            <!-- // date -->
                          </span>
                        </div>
                        <!-- // created -->

                        <!-- updated -->
                        <div *ngIf="user.user.updated" class="col-6 col-lg-3 d-flex flex-column gap-1 pt-1">
                          <span class="zx-text-tiny-tiny opacity-75 p-0">
                            {{ "my-profile.updated" | translate }}
                          </span>
                          <span class="zx-text-small zx-text-sm-medium opacity-75 p-0 d-flex flex-column gap-1">
                            <!-- date -->
                            <span>
                              {{ user.user.updated | date:'dd/MM/yy' }}
                            </span>
                            <span>
                              <span>
                                {{ "my-orders.at" | translate }}
                              </span>
                              <span class="zx-100-opp">-</span>
                              <span>
                                {{ user.user.updated | date:'HH:mm' }}
                              </span>
                            </span>
                            <!-- // date -->
                          </span>
                        </div>
                        <!-- // updated -->

                        <!-- discount -->
                        <div *ngIf="user.user.discount && user.user.discount !== 0 && user.user.discount !== 100"
                          class="col-6 col-lg-3 d-flex flex-column gap-1 pt-1">
                          <span class="zx-text-tiny-tiny opacity-75 p-0">
                            {{ "my-profile.permanent-discount" | translate }}
                          </span>
                          <span class="zx-text-small zx-text-sm-medium">
                            <span *ngIf="isRTL">%</span>
                            <span>
                              {{ user.user.discount }}
                            </span>
                            <span *ngIf="!isRTL">%</span>
                            <span>
                              {{ "my-orders.discount" | translate }}
                            </span>
                          </span>
                        </div>
                        <!-- // discount -->

                        <!-- payment per lap -->
                        <div *ngIf="user.user.discount && user.user.discount === 100"
                          class="col-6 col-lg-3 d-flex flex-column pt-1">
                          <span class="zx-text-tiny-tiny opacity-75 p-0">
                            {{ "my-profile.permanent-discount" | translate }}
                          </span>
                          <span class="d-flex flex-column">
                            <span class="zx-text-small zx-text-sm-medium">
                              {{ "my-profile.payment-per-lap" | translate }}
                            </span>
                            <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                              {{ "my-profile.payment-per-lap-explain" | translate }}
                            </span>
                          </span>
                        </div>
                        <!-- // payment per lap -->

                        <!-- points -->
                        <div *ngIf="user.user.points && user.user.points !== 0"
                          class="col-6 col-lg-3 d-flex flex-column gap-1 pt-1">
                          <span class="zx-text-tiny-tiny opacity-75 p-0">
                            {{ "my-profile.points" | translate }}
                          </span>
                          <span>
                            <span class="zx-text-small zx-text-sm-medium">
                              {{ user.user.points }}
                            </span>
                            <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                              {{ "printing-table.points-short" | translate }}
                            </span>
                          </span>
                        </div>
                        <!-- // points -->

                        <!-- payment method -->
                        <div class="col-6 col-lg-3 d-flex flex-column gap-1 pt-1">
                          <span class="zx-text-tiny-tiny opacity-75 p-0">
                            {{ "main-nav.methods-of-payment" | translate }}
                          </span>
                          <span class="d-flex flex-column">
                            <span *ngIf="user.user.zCreditInfo?.cardNum" class="zx-text-small zx-text-sm-medium">
                              <span>{{ getCCLastDigits(user.user.zCreditInfo?.cardNum) }}</span>
                              <span class="zx-100-opacity">-</span>
                              <span>**** **** ****</span>
                            </span>
                            <span *ngIf="!user.user.zCreditInfo?.cardNum" class="zx-text-tiny">
                              {{ "my-cc-no-credit-info" | translate }}
                            </span>
                          </span>
                        </div>
                        <!-- // payment method -->

                        <!-- roles -->
                        <div class="col-6 col-lg-3 d-flex flex-column gap-1 pt-1">
                          <span class="zx-text-tiny-tiny opacity-75 p-0">
                            {{ "my-profile.permissions" | translate }}
                          </span>
                          <span class="d-flex flex-column">
                            <span *ngFor="let role of user.user.roles" class="zx-text-tiny zx-text-sm-small">
                              - {{ role }}
                            </span>
                          </span>
                        </div>
                        <!-- // roles -->

                        <!-- language -->
                        <div class="col-6 col-lg-3 d-flex flex-column gap-1 pt-1">
                          <span class="zx-text-tiny-tiny opacity-75 p-0">
                            {{ "su-management.users.language" | translate }}
                          </span>
                          <span class="zx-text-tiny zx-text-sm-small">
                            {{ "su-management.users.language." + getUserLanguage(user.user) | translate }}
                          </span>
                        </div>
                        <!-- // language -->

                        <!-- profile img -->
                        <div *ngIf="getUserProfileImg(user.user) && getUserProfileImg(user.user) !== ''"
                          class="col-6 col-lg-3 d-flex flex-column gap-1 pt-1">
                          <span class="zx-text-tiny-tiny opacity-75 p-0">
                            {{ "su-management.users.profile-img" | translate }}
                          </span>
                          <img class="rounded-circle svg zx-small-small-plus-icon-size zx-small-plus-icon-size-lg"
                            [src]="getUserProfileImg(user.user)" alt="Default Profile Image">
                        </div>
                        <!-- // profile img -->

                      </article>
                      <!-- === MAIN DATA CONTAINER === -->

                      <!-- === last places === -->
                      <article
                        *ngIf="user.user.home_printingServices_list[0].length > 0 && user.user.home_branches_list[0].length > 0"
                        class="w-100 d-flex flex-column overflow-auto pt-4">
                        <span class="zx-text-tiny-tiny opacity-75 p-0">
                          {{ 'su-management.last-place-plural' | translate }}
                        </span>
                        <div class="d-flex align-items-center gap-1 gap-md-2">
                          <article class="d-flex flex-column align-items-center gap-md-1 p-1"
                            *ngFor="let place of user.user.home_printingServices_list; index as i">
                            <div class="d-flex align-items-center gap-1 gap-md-2 w-100 rounded-3 py-1 px-2"
                              [class.zx-border-gray-v-light-mid]="!isDarkMode"
                              [class.zx-bg-dark-light-border]="isDarkMode">
                              <b class="zx-text-tiny-tiny px-2 zx-text-pink">
                                <span>#</span>
                                <span>{{i + 1}}</span>
                              </b>
                              <img [src]="'assets/images/branches/' + user.user.home_branches_list[i] + '.png'"
                                alt="Branchs Logo" class="zx-small-tiny-icon-size">
                              <span class="zx-text-tiny-tiny zx-text-sm-tiny" style="white-space: nowrap;">
                                {{ "choose-branch.naming." + user.user.home_printingServices_list[i] + "." +
                                user.user.home_branches_list[i] | translate }}
                              </span>
                            </div>
                          </article>
                        </div>
                      </article>
                      <!-- // === last places === -->

                    </div>
                    <!-- // === USER CONTENT DATA LINE === -->

                    <!-- action row -->
                    <mat-action-row
                      class="d-flex justify-content-between justify-content-sm-center align-items-center gap-2 gap-md-3">
                      <div class="d-flex row flex-grow-1">

                        <!-- add pts -->
                        <div class="col-6 col-md-3 d-flex justify-content-center">
                          <button mat-button color="primary" class="rounded-pill px-md-3" [disabled]="!isSU"
                            (click)="openAddPointsDialog(user.user)">
                            <b class="zx-text-tiny zx-text-sm-small">
                              {{ 'su-management.users.add-pts' | translate }}
                            </b>
                          </button>
                        </div>

                        <!-- orders -->
                        <div class="col-6 col-md-3 d-flex justify-content-center">
                          <button mat-button color="primary" class="rounded-pill px-md-3"
                            (click)="showUsersOrders(user.user)">
                            <b class="zx-text-tiny zx-text-sm-small">
                              {{ 'my-profile.go-to-order-many' | translate }}
                            </b>
                          </button>
                        </div>

                        <!-- edit -->
                        <div class="col-6 col-md-3 d-flex justify-content-center">
                          <button mat-button color="primary" class="rounded-pill px-md-3" [disabled]="!isSU"
                            (click)="editUserManiger(user.user)">
                            <b class="zx-text-tiny zx-text-sm-small">
                              {{ 'su-management.users.edit-user' | translate }}
                            </b>
                          </button>
                        </div>

                        <!-- delete -->
                        <div class="col-6 col-md-3 d-flex justify-content-center">
                          <button *ngIf="!user?.user?.isDeleted" mat-button color="warn" class="rounded-pill px-md-3"
                            (click)="openDeleteUserDialog(user.user)" [disabled]="!isSU">
                            <b class="zx-text-tiny zx-text-sm-small">
                              {{ 'su-management.users.delete-user' | translate }}
                            </b>
                          </button>
                          <span class="zx-text-tiny zx-text-sm-small text-red pt-2 fw-bold"
                            *ngIf="user?.user?.isDeleted">
                            {{ 'delete-user.success' | translate }}
                          </span>
                        </div>

                      </div>
                    </mat-action-row>

                  </mat-expansion-panel>
                </mat-accordion>
                <!-- // users accordion -->
              </section>
              <!-- // users -------------------------------------------------------------------------------------------------------- users -->

            </div>


          </div>
        </div>
        <!-- // content -->
      </mat-tab>
      <!-- // ===== ===== ===== ===== ===== ===== users ===== ===== ===== ===== ===== ===== -->
















































      <!-- ===== ===== ===== ===== ===== ===== inventory ===== ===== ===== ===== ===== ===== -->
      <mat-tab [disabled]="isLoadingTabChange" class="w-100 d-flex flex-grow-1 flex-column" label="inventory">
        <ng-template mat-tab-label>
          <div class="d-flex flex-column flex-lg-row-reverse align-items-center justify-content-center gap-1 gap-lg-2">
            <b class="zx-text-tiny-tiny zx-text-sm-small">
              {{ 'su-management.inventory-management.short' | translate }}
            </b>
            <mat-icon>ballot</mat-icon>
          </div>

        </ng-template>
        <!-- content -->
        <div class="w-100 d-flex h-100 flex-column">
          <!-- loading -->
          <div *ngIf="isLoadingPrinter || isLoading"
            class="w-100 d-flex flex-grow-1 flex-column align-items-center justify-content-center p-3 px-lg-5">
            <mat-spinner class="zx-medium-icon-size zx-medium-big-icon-size-lg"></mat-spinner>
          </div>

          <!-- content -->
          <div *ngIf="!isLoadingPrinter && !isLoading" class="w-100 d-flex flex-grow-1 flex-column p-3 px-lg-5">

            <!-- --------------- title --------------- -->
            <div class="w-100 d-flex justify-content-center zx-border-bottom-green-bold mb-4 pb-2 px-3 px-lg-5">
              <h6 class="fw-bold zx-text-medium zx-text-sm-big" [class.text-green]="!isDarkMode">
                {{ 'su-management.inventory-management' | translate }}
              </h6>
            </div>
            <!-- // --------------- title --------------- -->

            <!-- finished LOADING... inventory -->
            <div *ngIf="!isLoadingPrinter && !isLoading" class="fill-height px-2 pb-2 d-flex px-xl-5">

              <section class="w-100 d-flex flex-column">
                <!-- ---------- PAPERS status ---------- -->
                <div *ngIf="!branch?.isPicsPrinter" class="col-12 d-flex flex-column gap-lg-1">
                  <b class="zx-text-tiny zx-text-sm-small text-green w-100 text-center pb-2">
                    {{ 'su-management.paper-status' | translate }}
                  </b>
                  <div class="d-flex w-100 zx-border-bottom-green-bold mt-2 mb-3"></div>

                  <div class="w-100 d-flex justify-content-center">
                    <div class="d-flex w-100 row">
                      <div *ngFor="let paper of getConsumables('paper')"
                        class="col-12 col-lg-6 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center"
                        [class.col-xxl-3]="printingService === 'express'">
                        <div class="row w-100">
                          <!-- paper title -->
                          <div class="col-6 d-flex justify-content-center align-items-center">
                            <b class="zx-text-small zx-text-sm-medium">
                              <span *ngIf="printingService === 'plotter'">
                                {{ 'paper-type.name.' + paper.paperType.paperType | translate }}
                              </span>
                              <span *ngIf="printingService === 'express'">
                                {{ 'paper-type.name.' + paper.serial_name | translate }}
                              </span>
                            </b>
                          </div>
                          <!-- // paper title -->

                          <!-- paper weight and width -->
                          <div
                            class="col-6 d-flex flex-column flex-md-row gap-md-5 justify-content-md-end align-items-center px-lg-3">
                            <span>
                              <span class="zx-text-tiny">
                                <span *ngIf="printingService === 'plotter'">
                                  {{ paper.paperType.paperWeight }}
                                </span>
                                <span *ngIf="printingService === 'express'">
                                  {{ getPaperProperties('weight', paper) }}
                                </span>
                              </span>
                              <span class="zx-text-tiny-tiny">
                                {{ 'su-management.branches_paper-weight-g' | translate }}
                              </span>
                            </span>
                            <span>
                              <span class="zx-text-tiny">
                                <span *ngIf="printingService === 'plotter'">
                                  {{ roundDownTowDecimal(paper.paperType.paperWidth / 10) }}
                                </span>
                                <span *ngIf="printingService === 'express'">
                                  <span>
                                    {{ getPaperProperties('height', paper) }}
                                  </span>
                                  <span>
                                    ×
                                  </span>
                                  <span>
                                    {{ getPaperProperties('width', paper) }}
                                  </span>
                                </span>
                              </span>
                              <span class="zx-text-tiny-tiny">
                                {{ 'printing-table.dimensions-cm' | translate }}
                              </span>
                            </span>
                          </div>
                          <!-- // paper weight and width -->

                          <div class="col-12 d-flex w-100 zx-border-bottom-gray-v-light-mid my-1 my-md-2"></div>

                          <!-- paper inventory ? -->
                          <div class="d-flex flex-column align-items-center pt-2 gap-sm-1"
                            [class.col-6]="printingService === 'plotter'"
                            [class.col-12]="printingService === 'express'">
                            <span class="zx-text-tiny opacity-75">
                              {{ 'su-management.inventory-management.short' | translate }}
                            </span>
                            <span class="zx-text-small zx-text-sm-medium"
                              [class.text-red]="getCurrentStock('paper', paper) < 1"
                              [class.fw-bold]="getCurrentStock('paper', paper) < 1">
                              <span>
                                {{ getCurrentStock('paper', paper) }}
                              </span>
                              <span class="zx-text-tiny-tiny">
                                {{ 'su-management.units.short' | translate }}
                              </span>
                            </span>

                            <!-- edit inventory -->
                            <div *ngIf="!isLoadingInventory" class="d-flex align-items-center gap-1">
                              <button mat-icon-button (click)="changeNumberOfInventory('remove', 'paper', paper)"
                                [disabled]="getNumOfInventory('paper', paper) <= 0">
                                <mat-icon>remove</mat-icon>
                              </button>
                              <input class="zx-inventory-input" [class.zx-text-white-bg-transparent]="isDarkMode"
                                [ngModel]="getNumOfInventory('paper', paper)"
                                (ngModelChange)="setNumOfInventory('paper', paper, $event)" matInput type="number"
                                min="0">
                              <button mat-icon-button (click)="changeNumberOfInventory('add', 'paper', paper)">
                                <mat-icon>add</mat-icon>
                              </button>
                            </div>
                            <div *ngIf="isLoadingInventory"
                              class="w-100 d-flex justify-content-center align-items-center p-3">
                              <mat-spinner class="zx-small-icon-size"></mat-spinner>
                            </div>

                          </div>
                          <!-- // paper inventory ? -->

                          <!-- paper length (in meters) [plotter] -->
                          <div *ngIf="printingService === 'plotter'"
                            class="col-6 d-flex flex-column align-items-center pt-2 gap-sm-1">
                            <span class="zx-text-tiny opacity-75">
                              {{ 'su-management.branches_paper-linger-length' | translate }}
                            </span>
                            <b class="zx-text-small zx-text-sm-medium"
                              [class.text-green]="paper.status?.lingerLength && paper.status.lingerLength >= 10"
                              [class.text-red]="paper.status?.lingerLength && paper.status.lingerLength < 10">
                              <span>
                                {{ roundDownFourDecimal(paper.status.lingerLength) }}
                              </span>
                              <span class="zx-text-tiny-tiny">
                                {{ 'su-management.branches_m' | translate }}
                              </span>
                            </b>
                          </div>
                          <!-- // paper length (in meters) [plotter] -->

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- // ---------- PAPERS status ---------- -->

                <!-- ---------- INK status ---------- -->
                <div *ngIf="!branch?.isPicsPrinter" class="col-12 d-flex flex-column gap-lg-1 pt-4">
                  <b class="zx-text-tiny zx-text-sm-small text-green w-100 text-center pb-2">
                    {{ 'su-management.ink-status' | translate }}
                  </b>
                  <div class="d-flex w-100 zx-border-bottom-green-bold mt-2 mb-3"></div>

                  <div *ngIf="!isLoading" class="w-100 d-flex justify-content-center">
                    <div class="d-flex w-100 row">
                      <div *ngFor="let ink of getConsumables('ink')"
                        class="col-12 col-md-6 col-xl-4 col-xxl-3 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center">
                        <div class="row w-100">
                          <!-- ink title -->
                          <div class="col-6 d-flex justify-content-center align-items-center">
                            <b class="zx-text-small zx-text-sm-medium">
                              <span *ngIf="printingService === 'plotter'">
                                {{ ink.color }}
                              </span>
                              <span *ngIf="printingService === 'express'">
                                {{ ink.name }}
                              </span>
                            </b>
                          </div>
                          <!-- // ink title -->

                          <!-- ink description -->
                          <div
                            class="col-6 d-flex flex-column flex-md-row gap-md-5 justify-content-md-center align-items-center px-lg-5">
                            <span *ngIf="printingService === 'plotter'" class="zx-text-tiny">
                              {{ 'ink-type.name.' + ink.color | translate }}
                            </span>
                            <span *ngIf="printingService === 'express'" class="zx-text-tiny">
                              {{ 'ink-type.name.' + ink.name | translate }}
                            </span>
                          </div>
                          <!-- // ink weight and width -->

                          <div class="col-12 d-flex w-100 zx-border-bottom-gray-v-light-mid my-1 my-md-2"></div>

                          <!-- ink inventory ? -->
                          <div class="col-6 d-flex flex-column align-items-center pt-2 gap-sm-1">
                            <span class="zx-text-tiny opacity-75">
                              {{ 'su-management.inventory-management.short' | translate }}
                            </span>
                            <span class="zx-text-small zx-text-sm-medium"
                              [class.text-red]="getCurrentStock('ink', ink) < 1"
                              [class.fw-bold]="getCurrentStock('ink', ink) < 1">
                              <span>
                                {{ getCurrentStock('ink', ink) }}
                              </span>
                              <span class="zx-text-tiny-tiny">
                                {{ 'su-management.units.short' | translate }}
                              </span>
                            </span>

                            <!-- edit inventory -->
                            <div *ngIf="!isLoadingInventory" class="d-flex align-items-center gap-1">
                              <button mat-icon-button (click)="changeNumberOfInventory('remove', 'ink', ink)"
                                [disabled]="getNumOfInventory('ink', ink) <= 0">
                                <mat-icon>remove</mat-icon>
                              </button>
                              <input class="zx-inventory-input" [class.zx-text-white-bg-transparent]="isDarkMode"
                                [ngModel]="getNumOfInventory('ink', ink)"
                                (ngModelChange)="setNumOfInventory('ink', ink, $event)" matInput type="number" min="0">
                              <button mat-icon-button (click)="changeNumberOfInventory('add', 'ink', ink)">
                                <mat-icon>add</mat-icon>
                              </button>
                            </div>
                            <div *ngIf="isLoadingInventory"
                              class="w-100 d-flex justify-content-center align-items-center p-3">
                              <mat-spinner class="zx-small-icon-size"></mat-spinner>
                            </div>

                          </div>
                          <!-- // ink inventory ? -->

                          <!-- ink status -->
                          <div class="col-6 d-flex flex-column align-items-center pt-2 gap-sm-1">
                            <span class="zx-text-tiny opacity-75">
                              {{ 's-screen.plotter-que.title.status' | translate }}
                            </span>
                            <b [class.text-green]="ink.level >= 5" [class.text-red]="ink.level < 5">
                              <span class="zx-text-tiny">%</span>
                              <span class="zx-text-small zx-text-sm-medium">
                                {{ ink.level }}
                              </span>
                            </b>
                          </div>
                          <!-- // ink status -->

                        </div>
                      </div>
                      <!-- wastetanck [plotter] -->
                      <div *ngIf="printingService === 'plotter'"
                        class="col-12 col-xl-4 col-xxl-12 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center">
                        <div class="row w-100">
                          <!-- wastetanck title -->
                          <div class="col-6 d-flex justify-content-center align-items-center">
                            <b class="zx-text-small zx-text-sm-medium">
                              {{ 'ink-type.name.Waste' | translate }}
                            </b>
                          </div>
                          <!-- // wastetanck title -->

                          <div class="col-12 d-flex w-100 zx-border-bottom-gray-v-light-mid my-1 my-md-2"></div>

                          <!-- wastetanck inventory ? -->
                          <div *ngIf="printingService === 'plotter'"
                            class="col-6 d-flex flex-column align-items-center pt-2 gap-sm-1">
                            <span class="zx-text-tiny opacity-75">
                              {{ 'su-management.inventory-management.short' | translate }}
                            </span>
                            <span *ngIf="branch.printers" class="zx-text-small zx-text-sm-medium"
                              [class.text-red]="getCurrentStock('wastetanck', branch.printers[0].wasteInk) < 1"
                              [class.fw-bold]="getCurrentStock('wastetanck', branch.printers[0].wasteInk) < 1">
                              <span>
                                {{ getCurrentStock('wastetanck', branch.printers[0].wasteInk) }}
                              </span>
                              <span class="zx-text-tiny-tiny">
                                {{ 'su-management.units.short' | translate }}
                              </span>
                            </span>

                            <!-- edit inventory -->
                            <div *ngIf="!isLoadingInventory && branch.printers" class="d-flex align-items-center gap-1">
                              <button mat-icon-button
                                (click)="changeNumberOfInventory('remove', 'waste', branch.printers[0].wasteInk)"
                                [disabled]="getNumOfInventory('waste', branch.printers[0].wasteInk) <= 0">
                                <mat-icon>remove</mat-icon>
                              </button>
                              <input class="zx-inventory-input" [class.zx-text-white-bg-transparent]="isDarkMode"
                                [ngModel]="getNumOfInventory('waste', branch.printers[0].wasteInk)"
                                (ngModelChange)="setNumOfInventory('waste', branch.printers[0].wasteInk, $event)"
                                matInput type="number" min="0">
                              <button mat-icon-button
                                (click)="changeNumberOfInventory('add', 'waste', branch.printers[0].wasteInk)">
                                <mat-icon>add</mat-icon>
                              </button>
                            </div>
                            <div *ngIf="isLoadingInventory"
                              class="w-100 d-flex justify-content-center align-items-center p-3">
                              <mat-spinner class="zx-small-icon-size"></mat-spinner>
                            </div>

                          </div>
                          <!-- // wastetanck inventory ? -->

                          <!-- wastetanck status -->
                          <div *ngIf="branch.printers"
                            class="col-6 d-flex flex-column align-items-center pt-2 gap-sm-1">
                            <span class="zx-text-tiny opacity-75">
                              {{ 's-screen.plotter-que.title.status' | translate }}
                            </span>
                            <b [class.text-green]="branch.printers[0].wasteInk?.level < 90"
                              [class.text-red]="branch.printers[0].wasteInk?.level >= 90">
                              <span class="zx-text-tiny">%</span>
                              <span *ngIf="branch.printers" class="zx-text-small zx-text-sm-medium">
                                {{ branch.printers[0].wasteInk?.level }}
                              </span>
                            </b>
                          </div>
                          <!-- // wastetanck status -->

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- // ---------- INK status ---------- -->

                <!-- ---------- RIBON status ---------- -->
                <div *ngIf="branch?.isPicsPrinter && printingService === 'express'"
                  class="col-12 d-flex flex-column gap-lg-1">
                  <b class="zx-text-tiny zx-text-sm-small text-green w-100 text-center pb-2">
                    {{ 'su-management.ribon-status' | translate }}
                  </b>
                  <div class="d-flex w-100 zx-border-bottom-green-bold mt-2 mb-3"></div>

                  <div class="w-100 d-flex justify-content-center">
                    <div class="d-flex w-100 row">
                      <div class="col-12 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center"
                        [class.col-xxl-3]="printingService === 'express'">
                        <div class="row w-100">
                          <!-- ribon title -->
                          <div class="col-12 d-flex justify-content-center align-items-center">
                            <b class="zx-text-small zx-text-sm-medium">
                              {{ 'su-management.ribon' | translate }}
                            </b>
                          </div>
                          <!-- // ribon title -->

                          <div class="col-12 d-flex w-100 zx-border-bottom-gray-v-light-mid my-1 my-md-2"></div>

                          <!-- ribon ribons inventory ? -->
                          <div class="d-flex flex-column align-items-center pt-2 gap-sm-1 col-12 col-sm-6">
                            <span class="zx-text-tiny opacity-75">
                              {{ 'paper-type.name-short.ribons' | translate }}
                            </span>
                            <span class="zx-text-small zx-text-sm-medium"
                              [class.text-red]="getCurrentStock('ribon', 'ribons') < 1"
                              [class.fw-bold]="getCurrentStock('ribon', 'ribons') < 1">
                              <span>
                                {{ getCurrentStock('ribon', 'ribons') }}
                              </span>
                              <span class="zx-text-tiny-tiny">
                                {{ 'su-management.units.short' | translate }}
                              </span>
                            </span>

                            <!-- edit inventory -->
                            <div *ngIf="!isLoadingInventory" class="d-flex align-items-center gap-1">
                              <button mat-icon-button (click)="changeNumberOfInventory('remove', 'ribon', 'ribons')"
                                [disabled]="getNumOfInventory('ribon', 'ribons') <= 0">
                                <mat-icon>remove</mat-icon>
                              </button>
                              <input class="zx-inventory-input" [class.zx-text-white-bg-transparent]="isDarkMode"
                                [ngModel]="getNumOfInventory('ribon', 'ribons')"
                                (ngModelChange)="setNumOfInventory('paper', 'rebons', $event)" matInput type="number"
                                min="0">
                              <button mat-icon-button (click)="changeNumberOfInventory('add', 'ribon', 'ribons')">
                                <mat-icon>add</mat-icon>
                              </button>
                            </div>
                            <div *ngIf="isLoadingInventory"
                              class="w-100 d-flex justify-content-center align-items-center p-3">
                              <mat-spinner class="zx-small-icon-size"></mat-spinner>
                            </div>

                          </div>
                          <!-- // ribon ribons inventory ? -->

                          <!-- ribon images inventory ? -->
                          <div class="d-flex flex-column align-items-center pt-2 gap-sm-1 col-12 col-sm-6">
                            <span class="zx-text-tiny opacity-75">
                              {{ 'paper-type.name-short.images' | translate }}
                            </span>
                            <span class="zx-text-small zx-text-sm-medium"
                              [class.text-red]="getCurrentStock('ribon', 'images') < 1"
                              [class.fw-bold]="getCurrentStock('ribon', 'images') < 1">
                              <span>
                                {{ getCurrentStock('ribon', 'images') }}
                              </span>
                              <span class="zx-text-tiny-tiny">
                                {{ 'su-management.units.short' | translate }}
                              </span>
                            </span>

                            <!-- edit inventory -->
                            <div *ngIf="!isLoadingInventory" class="d-flex align-items-center gap-1">
                              <button mat-icon-button (click)="changeNumberOfInventory('remove', 'ribon', 'images')"
                                [disabled]="getNumOfInventory('ribon', 'images') <= 0">
                                <mat-icon>remove</mat-icon>
                              </button>
                              <input class="zx-inventory-input" [class.zx-text-white-bg-transparent]="isDarkMode"
                                [ngModel]="getNumOfInventory('ribon', 'images')"
                                (ngModelChange)="setNumOfInventory('paper', 'rebons', $event)" matInput type="number"
                                min="0">
                              <button mat-icon-button (click)="changeNumberOfInventory('add', 'ribon', 'images')">
                                <mat-icon>add</mat-icon>
                              </button>
                            </div>
                            <div *ngIf="isLoadingInventory"
                              class="w-100 d-flex justify-content-center align-items-center p-3">
                              <mat-spinner class="zx-small-icon-size"></mat-spinner>
                            </div>

                          </div>
                          <!-- // ribon images inventory ? -->

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- // ---------- RIBON status ---------- -->
              </section>
            </div>
            <!-- // finished LOADING... inventory -->

            <!-- <div *ngIf="isSU" class="d-flex w-100 justify-content-center pt-2">
              <button (click)="shoWallBranchesInventory()" mat-raised-button color="primary"
                class="rounded-pill px-md-3">
                <span class="zx-text-tiny-tiny zx-text-sm-small text-white">
                  {{ 'su-management.inventory-management.show-all-branches' | translate }}
                </span>
              </button>
            </div> -->

          </div>
        </div>
        <!-- // content -->
      </mat-tab>
      <!-- // ===== ===== ===== ===== ===== ===== inventory ===== ===== ===== ===== ===== ===== -->

















































      <!-- ===== ===== ===== ===== ===== ===== permissions ===== ===== ===== ===== ===== ===== -->
      <mat-tab [disabled]="!isSU || isLoadingTabChange" class="w-100 d-flex flex-grow-1 flex-column" label="branch">
        <ng-template mat-tab-label>
          <div class="d-flex flex-column flex-lg-row-reverse align-items-center justify-content-center gap-1 gap-lg-2">
            <b class="zx-text-tiny-tiny zx-text-sm-small">
              {{ 'my-profile.permissions' | translate }}
            </b>
            <mat-icon>how_to_reg</mat-icon>
          </div>
        </ng-template>
        <!-- content -->
        <div class="w-100 d-flex h-100 flex-column">
          <!-- loading -->
          <div *ngIf="isLoading || isLoadingPrinter"
            class="w-100 d-flex flex-grow-1 flex-column align-items-center justify-content-center p-3 px-lg-5 flex-grow-1">
            <mat-spinner class="zx-medium-icon-size zx-medium-big-icon-size-lg"></mat-spinner>
          </div>

          <!-- content -->
          <div *ngIf="!isLoadReport && !isLoadingPrinter" class="w-100 d-flex flex-grow-1 flex-column p-3 px-lg-5">

            <!-- --------------- title --------------- -->
            <div class="w-100 d-flex justify-content-center zx-border-bottom-green-bold mb-4 pb-2 px-3 px-lg-5">
              <h6 class="fw-bold zx-text-medium zx-text-sm-big" [class.text-green]="!isDarkMode">
                {{ 'su-management.branch-management' | translate }}
              </h6>
            </div>
            <!-- // --------------- title --------------- -->

            <div *ngIf="!isLoading && branch" class="fill-height px-2 pb-2 d-flex px-xl-5">

              <section class="w-100 d-flex flex-column">
                <!-- ---------- BM ---------- -->
                <div class="col-12 d-flex flex-column gap-lg-1">
                  <b class="zx-text-tiny zx-text-sm-small text-green w-100 text-center pb-2">
                    {{ 'su-management.branches_bm' | translate }}
                  </b>
                  <div class="d-flex w-100 zx-border-bottom-green-bold mt-2 mb-3"></div>
                  <div
                    class="w-100 d-flex flex-column align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center px-3 px-lg-5">
                    <!-- existing bm -->
                    <div class="row zx-max-w-420 zx-w-lg-100" *ngIf="branch.bm">
                      <!-- displayName -->
                      <span
                        class="col-12 col-lg-4 d-flex justify-content-between justify-content-lg-center align-items-center py-2">
                        <span>
                          {{ 'my-profile.username' | translate }}
                        </span>
                        <span class="d-none d-lg-inline">:</span>
                        <span class="zx-100-opp d-none d-lg-inline">_</span>
                        <span>
                          {{ branch.bm.displayName }}
                        </span>
                      </span>
                      <!-- email -->
                      <span
                        class="col-12 col-lg-4 d-flex justify-content-between justify-content-lg-center align-items-center py-2">
                        <span>
                          {{ 'my-profile.email' | translate }}
                        </span>
                        <span class="d-none d-lg-inline">:</span>
                        <span class="zx-100-opp d-none d-lg-inline">_</span>
                        <span>
                          {{ branch.bm.email }}
                        </span>
                      </span>
                      <!-- phone -->
                      <span
                        class="col-12 col-lg-4 d-flex justify-content-between justify-content-lg-center align-items-center py-2">
                        <span>
                          {{ 'my-profile.phone' | translate }}
                        </span>
                        <span class="d-none d-lg-inline">:</span>
                        <span class="zx-100-opp d-none d-lg-inline">_</span>
                        <span *ngIf="branch.bm.phone" class="d-flex flex-row-reverse">
                          <span>0</span>
                          <span>
                            {{ ('0' + branch.bm.phone.toString()).slice(1, 3) }}
                          </span>
                          <span>-</span>
                          <span>
                            {{ ('0' + branch.bm.phone.toString()).slice(3, 7) }}
                          </span>
                          <span>-</span>
                          <span>
                            {{ ('0' + branch.bm.phone.toString()).slice(7) }}
                          </span>
                        </span>
                        <span *ngIf="!branch.bm.phone">
                          {{ 'su-management.not-existing' | translate }}
                        </span>
                      </span>
                      <div class="col-12 d-flex justify-content-center align-items-center py-2">
                        <button (click)="toReplaceBmMode()" mat-button color="primary" class="rounded-pill px-md-3"
                          [disabled]="!isSU">
                          <b *ngIf="!isReplacingBmMode" class="zx-text-tiny-tiny zx-text-sm-small">
                            {{ 'su-management.replace_bm' | translate }}
                          </b>
                          <b *ngIf="isReplacingBmMode" class="zx-text-tiny-tiny zx-text-sm-small text-red">
                            {{ 'su-management.branches_cancel' | translate }}
                          </b>
                        </button>
                      </div>
                    </div>
                    <!-- no existing bm -->
                    <div class="row w-100" *ngIf="!branch.bm && !isReplacingBmMode && !isLoadingPermitions">
                      <span class="col-12 col-lg-4 d-flex justify-content-center align-items-center py-2">
                        {{ 'su-management.not-existing' | translate }}
                      </span>
                      <div class="col-12 d-flex justify-content-center align-items-center py-2">
                        <button (click)="toReplaceBmMode()" mat-button color="primary" class="rounded-pill px-md-3"
                          [disabled]="!isSU">
                          <b class="zx-text-tiny-tiny zx-text-sm-small">
                            {{ 'su-management.add_bm' | translate }}
                          </b>
                        </button>
                      </div>
                    </div>
                    <!-- spinner -->
                    <div class="col-12 d-flex justify-content-center align-items-center py-2"
                      *ngIf="isLoadingPermitions">
                      <mat-spinner class="zx-small-tiny-plus-icon-size text-red"></mat-spinner>
                    </div>
                    <!-- replacing bm -->
                    <div class="row w-100" *ngIf="isReplacingBmMode && !isLoadingPermitions">
                      <span class="col-12 d-flex justify-content-center align-items-center py-2">
                        {{ 'su-management.add_bm' | translate }}
                      </span>
                      <!-- search -->
                      <div class="col-12 search-container p-2 pb-3">
                        <input type="text" class="form-control" [placeholder]="usersSearchPlaceholder"
                          [(ngModel)]="userSearchText" (ngModelChange)="filterUsers()">
                      </div>
                      <div *ngIf="userSearchText !== ''">
                        <div mat-ripple *ngFor="let user of users; index as i"
                          class="col-12 d-flex justify-content-between align-items-center p-2 px-lg-4 shadow-85 rounded-2 step-item-hover"
                          (click)="replaceBm(user.user._id)">
                          <mat-icon>cached</mat-icon>
                          <span *ngIf="user.user.email.length < 15">
                            {{ user?.user?.email }}
                          </span>
                          <span class="d-flex" [class.flex-row-reverse]="isRTL" *ngIf="user.user.email.length >= 15">
                            <span class="d-none d-lg-inline">
                              {{ user?.user?.email }}
                            </span>
                            <span class="d-lg-none">
                              {{ user?.user?.email | slice:0:20 }}
                            </span>
                            <span class="d-lg-none" *ngIf="user?.user?.email?.length > 20">...</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ---------- ST ---------- -->
                <div class="col-12 d-flex flex-column gap-lg-1 pt-3">
                  <b class="zx-text-tiny zx-text-sm-small text-green w-100 text-center pb-2">
                    {{ 'su-management.branches_st' | translate }}
                  </b>
                  <div class="d-flex w-100 zx-border-bottom-green-bold mt-2 mb-3"></div>
                  <article *ngIf="branch.st && branch.st.length > 0"
                    class="d-flex d-flex flex-column w-100 align-items-center gap-lg-1">
                    <div *ngFor="let st of branch.st"
                      class="w-100 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center px-3 px-lg-5">
                      <!-- existing st -->
                      <div class="row zx-max-w-420 zx-w-lg-100">
                        <!-- displayName -->
                        <span
                          class="col-12 col-lg-4 d-flex justify-content-between justify-content-lg-center align-items-center py-2">
                          <span>
                            {{ 'my-profile.username' | translate }}
                          </span>
                          <span class="d-none d-lg-inline">:</span>
                          <span class="zx-100-opp d-none d-lg-inline">_</span>
                          <span>
                            {{ st.displayName }}
                          </span>
                        </span>
                        <!-- email -->
                        <span
                          class="col-12 col-lg-4 d-flex justify-content-between justify-content-lg-center align-items-center py-2">
                          <span>
                            {{ 'my-profile.email' | translate }}
                          </span>
                          <span class="d-none d-lg-inline">:</span>
                          <span class="zx-100-opp d-none d-lg-inline">_</span>
                          <span>
                            {{ st.email }}
                          </span>
                        </span>
                        <!-- phone -->
                        <span
                          class="col-12 col-lg-4 d-flex justify-content-between justify-content-lg-center align-items-center py-2">
                          <span>
                            {{ 'my-profile.phone' | translate }}
                          </span>
                          <span class="d-none d-lg-inline">:</span>
                          <span class="zx-100-opp d-none d-lg-inline">_</span>
                          <span *ngIf="st.phone" class="d-flex flex-row-reverse">
                            <span>0</span>
                            <span>
                              {{ ('0' + st.phone.toString()).slice(1, 3) }}
                            </span>
                            <span>-</span>
                            <span>
                              {{ ('0' + st.phone.toString()).slice(3, 7) }}
                            </span>
                            <span>-</span>
                            <span>
                              {{ ('0' + st.phone.toString()).slice(7) }}
                            </span>
                          </span>
                          <span *ngIf="!st.phone">
                            {{ 'su-management.not-existing' | translate }}
                          </span>
                        </span>
                        <div class="col-12 d-flex justify-content-center align-items-center py-2">
                          <button (click)="removeSt(st._id)" mat-button color="primary" class="rounded-pill px-md-3"
                            [disabled]="!isSU">
                            <b class="zx-text-tiny-tiny zx-text-sm-small text-red">
                              {{ 'su-management.remove_st' | translate }}
                            </b>
                          </button>
                        </div>
                      </div>
                    </div>
                  </article>
                  <article class="d-flex d-flex flex-column w-100 align-items-center gap-lg-1">
                    <div
                      class="w-100 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center px-3">
                      <!-- adding st -->
                      <div class="row w-100">
                        <span class="col-12 d-flex justify-content-center align-items-center py-2">
                          {{ 'su-management.add_st' | translate }}
                        </span>
                        <!-- search -->
                        <div class="col-12 search-container p-2 pb-3">
                          <input type="text" class="form-control" [placeholder]="usersSearchPlaceholder"
                            [(ngModel)]="userSearchText" (ngModelChange)="filterUsers()">
                        </div>
                        <div *ngIf="userSearchText !== ''">
                          <div mat-ripple *ngFor="let user of users; index as i"
                            class="col-12 d-flex justify-content-between align-items-center p-2 px-lg-4 shadow-85 rounded-2 step-item-hover"
                            (click)="addSt(user.user._id)">
                            <mat-icon>cached</mat-icon>
                            <span *ngIf="user.user.email.length < 15">
                              {{ user?.user?.email }}
                            </span>
                            <span class="d-flex" [class.flex-row-reverse]="isRTL" *ngIf="user.user.email.length >= 15">
                              <span class="d-none d-lg-inline">
                                {{ user?.user?.email }}
                              </span>
                              <span class="d-lg-none">
                                {{ user?.user?.email | slice:0:20 }}
                              </span>
                              <span class="d-lg-none" *ngIf="user?.user?.email?.length > 20">...</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </section>
            </div>

          </div>
        </div>
        <!-- // content -->
      </mat-tab>
      <!-- // ===== ===== ===== ===== ===== ===== permissions ===== ===== ===== ===== ===== ===== -->




      <!-- no existing st -->
      <div class="row w-100" *ngIf="!branch.st && !isReplacingBmMode && !isLoadingPermitions">
        <span class="col-12 col-lg-4 d-flex justify-content-center align-items-center py-2">
          {{ 'su-management.not-existing' | translate }}
        </span>
        <div class="col-12 d-flex justify-content-center align-items-center py-2">
          <button (click)="toReplaceBmMode()" mat-button color="primary" class="rounded-pill px-md-3"
            [disabled]="!isSU">
            <b class="zx-text-tiny-tiny zx-text-sm-small">
              {{ 'su-management.add_bm' | translate }}
            </b>
          </button>
        </div>
      </div>
      <!-- spinner -->
      <div class="col-12 d-flex justify-content-center align-items-center py-2" *ngIf="isLoadingPermitions">
        <mat-spinner class="zx-small-tiny-plus-icon-size text-red"></mat-spinner>
      </div>
      <!-- replacing bm -->
      <div class="row w-100" *ngIf="isReplacingBmMode && !isLoadingPermitions">
        <span class="col-12 d-flex justify-content-center align-items-center py-2">
          {{ 'su-management.add_bm' | translate }}
        </span>
        <!-- search -->
        <div class="col-12 search-container p-2 pb-3">
          <input type="text" class="form-control" [placeholder]="usersSearchPlaceholder" [(ngModel)]="userSearchText"
            (ngModelChange)="filterUsers()">
        </div>
        <div *ngIf="userSearchText !== ''">
          <div mat-ripple *ngFor="let user of users; index as i"
            class="col-12 d-flex justify-content-between align-items-center p-2 px-lg-4 shadow-85 rounded-2 step-item-hover"
            (click)="replaceBm(user.user._id)">
            <mat-icon>cached</mat-icon>
            <span *ngIf="user.user.email.length < 15">
              {{ user?.user?.email }}
            </span>
            <span class="d-flex" [class.flex-row-reverse]="isRTL" *ngIf="user.user.email.length >= 15">
              <span>
                {{ user?.user?.email | slice:0:15 }}
              </span>
              <span>...</span>
            </span>
          </div>
        </div>
      </div>
      <!-- // ===== ===== ===== ===== ===== ===== permissions ===== ===== ===== ===== ===== ===== -->


















































      <!-- ===== ===== ===== ===== ===== ===== report ===== ===== ===== ===== ===== ===== -->
      <mat-tab [disabled]="!isManiger() || isLoadingTabChange" class="w-100 d-flex flex-grow-1 flex-column"
        label="report">
        <ng-template mat-tab-label>
          <div class="d-flex flex-column flex-lg-row-reverse align-items-center justify-content-center gap-1 gap-lg-2">
            <b class="zx-text-tiny-tiny zx-text-sm-small">
              {{ 'su-management.report-management.short' | translate }}
            </b>
            <mat-icon>equalizer</mat-icon>
          </div>
        </ng-template>
        <!-- content -->
        <div class="w-100 d-flex h-100 flex-column">
          <!-- loading -->
          <div *ngIf="isLoading || isLoadReport"
            class="w-100 d-flex flex-grow-1 flex-column align-items-center justify-content-center p-3 px-lg-5 flex-grow-1">
            <mat-spinner class="zx-medium-icon-size zx-medium-big-icon-size-lg"></mat-spinner>
          </div>

          <!-- content -->
          <div *ngIf="!isLoading && !isLoadReport" class="w-100 d-flex flex-grow-1 flex-column p-3 px-lg-5">

            <!-- --------------- title --------------- -->
            <div class="w-100 d-flex justify-content-center zx-border-bottom-green-bold mb-4 pb-2 px-3 px-lg-5">
              <h6 class="fw-bold zx-text-medium zx-text-sm-big" [class.text-green]="!isDarkMode">
                {{ 'su-management.report-management' | translate }}
              </h6>
            </div>
            <!-- // --------------- title --------------- -->

            <div *ngIf="!isLoading && branch" class="fill-height px-2 pb-2 d-flex px-xl-5" style="overflow-x: hidden">

              <section class="w-100 d-flex justify-content-center col-12">
                <!-- ---------- NONTH AND YEAR ---------- -->
                <!-- month -->
                <div class="d-flex align-items-center gap-1 px-sm-4">
                  <button mat-icon-button (click)="changeMonth('remove')">
                    <mat-icon>remove</mat-icon>
                  </button>
                  <input class="zx-inventory-input" [class.zx-text-white-bg-transparent]="isDarkMode"
                    [ngModel]="getMonth()" (ngModelChange)="setMonth($event)" matInput type="number" min="0">
                  <button mat-icon-button (click)="changeMonth('add')">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
                <!-- year -->
                <div class="d-flex align-items-center gap-1 px-sm-4">
                  <button mat-icon-button (click)="changeYear('remove')">
                    <mat-icon>remove</mat-icon>
                  </button>
                  <input class="zx-inventory-input" [class.zx-text-white-bg-transparent]="isDarkMode"
                    [ngModel]="getYear()" (ngModelChange)="setYear($event)" matInput type="number" min="2000"
                    max="2100">
                  <button mat-icon-button (click)="changeYear('add')">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </section>

              <section class="col-12 d-flex flex-column align-items-center pt-5" *ngIf="isLoadReport">
                <mat-spinner class="zx-small-tiny-plus-icon-size text-red"></mat-spinner>
              </section>

              <section>
                <div class="col-12 d-flex flex-column gap-lg-1" *ngIf="!isLoadReport">
                  <!-- ---------- TOTAL SUM ---------- -->
                  <b class="zx-text-tiny zx-text-sm-small text-green w-100 text-center py-2">
                    {{ 'su-management.report.total-sum' | translate }}
                  </b>
                  <div class="d-flex w-100 zx-border-bottom-green-bold mt-2 mb-3"></div>
                  <div class="w-100 d-flex justify-content-center shadow-85 rounded-2">
                    <div class="zx-max-w-420 d-flex align-items-center py-2 mt-2 justify-content-center px-3">
                      <div class="row w-100" *ngIf="!isLoadReport">
                        <!-- total sum with vat -->
                        <span class="col-12 d-flex justify-content-between align-items-center py-2">
                          <span>
                            {{ 'su-management.report.total-sum.with-vat' | translate }}
                          </span>
                          <span>
                            <span>
                              {{ roundDownTowDecimalCeil(reportData.totalCost) }}
                            </span>
                            <span>
                              {{ 'printing-table.nis' | translate }}
                            </span>
                          </span>
                        </span>
                        <!-- total sum with NO vat -->
                        <span class="col-12 d-flex justify-content-between align-items-center py-2">
                          <span>
                            <span>
                              {{ 'su-management.report.total-sum.without-vat' | translate }}
                            </span>
                            <span class="zx-text-tiny">
                              <span>(</span>
                              <span>{{ getVat() * 100 }}</span>
                              <span>%</span>
                              <span>)</span>
                            </span>
                          </span>
                          <span>
                            <span>
                              {{ roundDownTowDecimalCeil(reportData.totalCost / (1 + getVat()) ) }}
                            </span>
                            <span>
                              {{ 'printing-table.nis' | translate }}
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- // ---------- TOTAL SUM ---------- -->

                  <!-- ---------- BM DATA ---------- -->
                  <b class="zx-text-tiny zx-text-sm-small text-green w-100 text-center pb-2 pt-3">
                    {{ 'su-management.branches_bm' | translate }}
                  </b>
                  <div class="d-flex w-100 zx-border-bottom-green-bold mt-2 mb-3"></div>
                  <div class="w-100 d-flex justify-content-center shadow-85 rounded-2">
                    <div class="zx-max-w-420 d-flex align-items-center py-2 mt-2 justify-content-center px-3">
                      <div class="row w-100" *ngIf="!isLoadReport">
                        <!-- total sum with vat -->
                        <span class="col-12 d-flex justify-content-between align-items-center py-2">
                          <span>
                            {{ 'su-management.branches_bm' | translate }}
                          </span>
                          <span *ngIf="reportData?.bmEmail !== ''">
                            <span class="d-lg-none" *ngIf="reportData?.bmEmail && reportData.bmEmail.length > 13">
                              <span>...</span>
                              <span>{{ reportData.bmEmail | slice:0:12 }}</span>
                            </span>
                            <span class="d-lg-none" *ngIf="reportData?.bmEmail && reportData.bmEmail.length <= 13">
                              {{ reportData.bmEmail }}
                            </span>
                            <span class="d-none d-lg-inline">
                              {{ reportData.bmEmail }}
                            </span>
                          </span>
                          <span *ngIf="reportData?.bmEmail === ''">
                            {{ 'su-management.not-existing' | translate }}
                          </span>
                        </span>
                        <!-- total sum with vat -->
                        <span *ngIf="reportData?.bmEmail !== ''"
                          class="col-12 d-flex justify-content-between align-items-center py-2">
                          <span>
                            {{ 'su-management.report.bm.total-sum' | translate }}
                          </span>
                          <span>
                            <span>
                              {{ roundDownTowDecimalCeil(reportData.bmTotalCost) }}
                            </span>
                            <span>
                              {{ 'printing-table.nis' | translate }}
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- // ---------- BM DATA ---------- -->

                  <!-- ---------- PRICING DATA ---------- -->
                  <b *ngIf="isSU" class="zx-text-tiny zx-text-sm-small text-green w-100 text-center pb-2 pt-3">
                    {{ 'su-management.report.prices' | translate }}
                  </b>
                  <div *ngIf="isSU" class="d-flex w-100 zx-border-bottom-green-bold mt-2 mb-3"></div>

                  <!-- [express] -->
                  <div *ngIf="isSU && !isLoading && printingService === 'express'" class="d-flex row">

                    <!-- paper -->
                    <div *ngFor="let paper of branch?.consumables?.papers"
                      class="col-12 col-md-6 col-xl-4 col-xxl-3 d-flex flex-column align-items-center mt-2">
                      <article class="w-100 d-flex flex-column align-items-center shadow-85 rounded-2 py-2 px-3">
                        <b class="zx-text-small text-green">
                          {{ "paper-type.name." + paper.serial_name | translate }}
                        </b>

                        <!-- == prices [single color] == -->
                        <div class="w-100 d-flex align-items-center">
                          <!-- properties -->
                          <div class="d-flex flex-column gap-1 gap-lg-2">
                            <!-- sides -->
                            <div *ngIf="isDubbleSidedPaper(paper)"
                              class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                              [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                              <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                                {{ "printing-table.sides-one" | translate }}
                              </span>
                            </div>
                            <!-- color -->
                            <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                              [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                              <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                                {{ "printing-table.color-color" | translate }}
                              </span>
                            </div>
                          </div>
                          <!-- prices -->
                          <div class="d-flex flex-column gap-1 gap-lg-2 flex-grow-1 align-items-end">
                            <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                                {{ branch.pricing.x }}
                              </span>
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                                {{ "su-management.report.prices.first-pages" | translate }}
                              </span>
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                                class="opacity-50">:</span>
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                                class="zx-100-opp">-</span>
                              <b>
                                {{ getPaperPriceExpress(paper.paperName, 'first', 'single', 'color') }}
                              </b>
                              <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                {{ "printing-table.nis" | translate }}
                              </span>
                            </span>
                            <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                              class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                              <span class="opacity-50">
                                {{ "su-management.report.prices.extra-pages" | translate }}
                              </span>
                              <span class="opacity-50">:</span>
                              <span class="zx-100-opp">-</span>
                              <b>
                                {{ getPaperPriceExpress(paper.paperName, 'more', 'single', 'color') }}
                              </b>
                              <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                {{ "printing-table.nis" | translate }}
                              </span>
                            </span>
                          </div>
                        </div>
                        <div class="d-flex w-100 zx-border-bottom-gray-v-light-mid my-2"></div>
                        <!-- == prices [single bw] == -->
                        <div class="w-100 d-flex align-items-center">
                          <!-- properties -->
                          <div class="d-flex flex-column gap-1 gap-lg-2">
                            <!-- sides -->
                            <div *ngIf="isDubbleSidedPaper(paper)"
                              class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                              [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                              <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                                {{ "printing-table.sides-one" | translate }}
                              </span>
                            </div>
                            <!-- color -->
                            <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                              [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                              <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                                {{ "printing-table.color-bandw" | translate }}
                              </span>
                            </div>
                          </div>
                          <!-- prices -->
                          <div class="d-flex flex-column gap-1 gap-lg-2 flex-grow-1 align-items-end">
                            <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                                {{ branch.pricing.x }}
                              </span>
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                                {{ "su-management.report.prices.first-pages" | translate }}
                              </span>
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                                class="opacity-50">:</span>
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                                class="zx-100-opp">-</span>
                              <b>
                                {{ getPaperPriceExpress(paper.paperName, 'first', 'single', 'bw') }}
                              </b>
                              <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                {{ "printing-table.nis" | translate }}
                              </span>
                            </span>
                            <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                              class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                              <span class="opacity-50">
                                {{ "su-management.report.prices.extra-pages" | translate }}
                              </span>
                              <span class="opacity-50">:</span>
                              <span class="zx-100-opp">-</span>
                              <b>
                                {{ getPaperPriceExpress(paper.paperName, 'more', 'single', 'bw') }}
                              </b>
                              <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                {{ "printing-table.nis" | translate }}
                              </span>
                            </span>
                          </div>
                        </div>
                        <div *ngIf="isDubbleSidedPaper(paper)"
                          class="d-flex w-100 zx-border-bottom-gray-v-light-mid my-2">
                        </div>
                        <!-- == prices [double color] == -->
                        <div *ngIf="isDubbleSidedPaper(paper)" class="w-100 d-flex align-items-center">
                          <!-- properties -->
                          <div class="d-flex flex-column gap-1 gap-lg-2">
                            <!-- sides -->
                            <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                              [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                              <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                                {{ "printing-table.sides-two" | translate }}
                              </span>
                            </div>
                            <!-- color -->
                            <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                              [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                              <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                                {{ "printing-table.color-color" | translate }}
                              </span>
                            </div>
                          </div>
                          <!-- prices -->
                          <div class="d-flex flex-column gap-1 gap-lg-2 flex-grow-1 align-items-end">
                            <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                                {{ branch.pricing.x }}
                              </span>
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                                {{ "su-management.report.prices.first-pages" | translate }}
                              </span>
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                                class="opacity-50">:</span>
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                                class="zx-100-opp">-</span>
                              <b>
                                {{ getPaperPriceExpress(paper.paperName, 'first', 'double', 'color') }}
                              </b>
                              <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                {{ "printing-table.nis" | translate }}
                              </span>
                            </span>
                            <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                              class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                              <span class="opacity-50">
                                {{ "su-management.report.prices.extra-pages" | translate }}
                              </span>
                              <span class="opacity-50">:</span>
                              <span class="zx-100-opp">-</span>
                              <b>
                                {{ getPaperPriceExpress(paper.paperName, 'more', 'double', 'color') }}
                              </b>
                              <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                {{ "printing-table.nis" | translate }}
                              </span>
                            </span>
                          </div>
                        </div>
                        <div *ngIf="isDubbleSidedPaper(paper)"
                          class="d-flex w-100 zx-border-bottom-gray-v-light-mid my-2">
                        </div>
                        <!-- == prices [double bw] == -->
                        <div *ngIf="isDubbleSidedPaper(paper)" class="w-100 d-flex align-items-center">
                          <!-- properties -->
                          <div class="d-flex flex-column gap-1 gap-lg-2">
                            <!-- sides -->
                            <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                              [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                              <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                                {{ "printing-table.sides-two" | translate }}
                              </span>
                            </div>
                            <!-- color -->
                            <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                              [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                              <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                                {{ "printing-table.color-bandw" | translate }}
                              </span>
                            </div>
                          </div>
                          <!-- prices -->
                          <div class="d-flex flex-column gap-1 gap-lg-2 flex-grow-1 align-items-end">
                            <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                                {{ branch.pricing.x }}
                              </span>
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')" class="opacity-50">
                                {{ "su-management.report.prices.first-pages" | translate }}
                              </span>
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                                class="opacity-50">:</span>
                              <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                                class="zx-100-opp">-</span>
                              <b>
                                {{ getPaperPriceExpress(paper.paperName, 'first', 'double', 'bw') }}
                              </b>
                              <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                {{ "printing-table.nis" | translate }}
                              </span>
                            </span>
                            <span *ngIf="isExtraPriceExpress(paper.paperName, 'single', 'color')"
                              class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                              <span class="opacity-50">
                                {{ "su-management.report.prices.extra-pages" | translate }}
                              </span>
                              <span class="opacity-50">:</span>
                              <span class="zx-100-opp">-</span>
                              <b>
                                {{ getPaperPriceExpress(paper.paperName, 'more', 'double', 'bw') }}
                              </b>
                              <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                {{ "printing-table.nis" | translate }}
                              </span>
                            </span>
                          </div>
                        </div>
                      </article>
                    </div>

                  </div>
                  <!-- // [express] -->

                  <!-- [plotter] -->
                  <div *ngIf="isSU && branch.printers && !isLoading && printingService === 'plotter'"
                    class="w-100 d-flex row">

                    <!-- paper -->
                    <div *ngFor="let paper of branch.printers[0].inputBins"
                      class="col-12 col-md-6 col-xl-4 col-xxl-3 d-flex flex-column align-items-center mt-2">
                      <article class="w-100 d-flex flex-column align-items-center shadow-85 rounded-2 py-2 px-3">
                        <b class="zx-text-small text-green pb-2">
                          {{ "paper-type.name." + paper.paperType.paperType | translate }}
                        </b>

                        <!-- == prices == -->
                        <div *ngFor="let price of paper.paperType.pricingPoints"
                          class="w-100 d-flex align-items-center pb-2">
                          <!-- properties -->
                          <div class="d-flex flex-column gap-1 gap-lg-2">
                            <!-- % -->
                            <div class="d-flex px-2 px-sm-3 py-lg-1 rounded-pill zx-bg-gray"
                              [class.zx-bg-gray-v-light-opacity]="isDarkMode">
                              <span class="zx-text-tiny zx-text-sm-small d-flex" [class.flex-row-reverse]="isRTL"
                                [class.zx-text-white]="isDarkMode">
                                <span>
                                  {{ price.min }}
                                </span>
                                <span>-</span>
                                <span>
                                  {{ price.max }}
                                </span>
                                <span>%</span>
                              </span>
                            </div>
                          </div>
                          <!-- prices -->
                          <div class="d-flex flex-column gap-1 gap-lg-2 flex-grow-1 align-items-end">
                            <span class="zx-text-tiny zx-text-sm-small" [class.zx-text-white]="isDarkMode">
                              <b>
                                {{ price.price }}
                              </b>
                              <span class="zx-text-tiny-tiny zx-text-sm-tiny">
                                {{ "printing-table.nis" | translate }}
                              </span>
                              <span class="zx-100-opp">-</span>
                              <span class="opacity-50 zx-text-tiny-tiny zx-text-sm-tiny">
                                {{ "su-management.report.prices.per-70-cm" | translate }}
                              </span>
                            </span>
                          </div>
                        </div>
                      </article>

                    </div>
                  </div>
                  <!-- // [plotter] -->

                  <!-- // ---------- PRICING DATA ---------- -->

                  <!-- ---------- ANNUAL STATISTICS ---------- -->
                  <!-- <b class="zx-text-tiny zx-text-sm-small text-green w-100 text-center pb-2 pt-3">
                    <span>
                      {{ 'su-management.report.annual-statistics' | translate }}
                    </span>
                    <span>
                      {{ getYear() }}
                    </span>
                  </b>
                  <div class="d-flex w-100 zx-border-bottom-green-bold mt-2 mb-3"></div>
                  <div
                    class="w-100 d-flex align-items-center shadow-85 rounded-2 py-2 mt-2 justify-content-center px-3">
                    <div class="row w-100" *ngIf="!isLoadReport">
                    </div>
                  </div> -->


                  <!-- ---------- // ANNUAL STATISTICS ---------- -->


                </div>
              </section>
            </div>

          </div>
        </div>
        <!-- // content -->
      </mat-tab>
      <!-- // ===== ===== ===== ===== ===== ===== report ===== ===== ===== ===== ===== ===== -->


















































    </mat-tab-group>

  </div>
</div>

<!-- --------------------------------- SUB SECTION -->
<div *ngIf="subPage !== 'branch' && subPage !== 'report'"
  class="py-2 d-flex justify-content-center shadow-85-strong zx-z-index-1">
  <!-- printer -->
  <div *ngIf="subPage === 'print' || subPage === 'printer'" class="d-flex row align-items-center w-100">
    <div class="d-flex justify-content-center align-items-center w-100 gap-3 gap-lg-4"
      [class.flex-row-reverse]="!isRTL">

      <!-- stop-queue BTN [plotter] -->
      <button *ngIf="printingService === 'plotter'" mat-raised-button class="rounded-pill w-100"
        (click)="openOrCloseQueue()">
        <span *ngIf="!isLoadingOpenOrCloseQueue">
          <span class="text-green" *ngIf="!getIsQueueStopped()">
            {{ "su-management.stop-queue" | translate }}
          </span>
          <span class="text-green fw-bold" *ngIf="getIsQueueStopped()">
            {{ "su-management.stop-queue-undo" | translate }}
          </span>
        </span>
        <span *ngIf="isLoadingOpenOrCloseQueue" class="w-100 d-flex justify-content-center align-items-center">
          <mat-spinner class="zx-small-tiny-plus-icon-size text-red"></mat-spinner>
        </span>
      </button>

      <!-- get-slack BTN [plotter] -->
      <button *ngIf="printingService === 'plotter'" mat-raised-button class="rounded-pill w-100"
        (click)="openOrCloseSlack()">
        <span *ngIf="!isLoadingOpenOrCloseSlack">
          <span class="text-green" *ngIf="!getisSlackOn()">
            {{ "su-management.get-slack" | translate }}
          </span>
          <span class="text-green fw-bold" *ngIf="getisSlackOn()">
            <span class="d-md-none">
              {{ "su-management.get-slack-undo.short" | translate }}
            </span>
            <span class="d-none d-md-inline">
              {{ "su-management.get-slack-undo" | translate }}
            </span>
          </span>
        </span>
        <span *ngIf="isLoadingOpenOrCloseSlack" class="w-100 d-flex justify-content-center align-items-center">
          <mat-spinner class="zx-small-tiny-plus-icon-size text-red"></mat-spinner>
        </span>
      </button>

      <!-- release print queue BTN [express] -->
      <button *ngIf="printingService === 'express'" mat-raised-button class="rounded-pill w-100"
        (click)="releaseQueue()">
        <span *ngIf="!isLoadingReleaseQueue">
          <span class="text-green" *ngIf="!getisSlackOn()">
            {{ "su-management.release-queue" | translate }}
          </span>
        </span>
        <span *ngIf="isLoadingReleaseQueue" class="w-100 d-flex justify-content-center align-items-center">
          <mat-spinner class="zx-small-tiny-plus-icon-size text-red"></mat-spinner>
        </span>
      </button>

      <!-- restart server BTN [express] -->
      <button *ngIf="isSU && printingService === 'express'" mat-raised-button class="rounded-pill w-100"
        (click)="restartServer()">
        <span *ngIf="!isLoadingRestartServer">
          <span class="text-green">
            {{ "su-management.restart-server" | translate }}
          </span>
        </span>
        <span *ngIf="isLoadingRestartServer" class="w-100 d-flex justify-content-center align-items-center">
          <mat-spinner class="zx-small-tiny-plus-icon-size text-red"></mat-spinner>
        </span>
      </button>

      <div *ngIf="isSU" class="d-flex align-items-center gap-1 gap-md-2">
        <!-- close-branch BTN -->
        <button mat-icon-button (click)="openSuCloseBranchDialog()"
          [matTooltip]="isBranchClose() ? ('su-management.branches_close-true' | translate) : ('su-management.branches_close-false' | translate)"
          matTooltipPosition="above">
          <mat-icon *ngIf="isBranchClose()" class="text-green">lock</mat-icon>
          <mat-icon *ngIf="!isBranchClose()" class="text-green">lock_open</mat-icon>
        </button>

        <!-- ===== SU MANU [plotter + express] ===== -->
        <img *ngIf="!isLoadingRestartServer" [matMenuTriggerFor]="resetServerManu"
          class="zx-small-plus-icon-size p-1 pt-2 svg c-pointer" src="assets/images/three-dots-icon.svg"
          alt="Image Options">
        <span *ngIf="isLoadingRestartServer">
          <mat-spinner class="zx-small-tiny-plus-icon-size text-red"></mat-spinner>
        </span>
        <mat-menu #resetServerManu="matMenu">
          <!-- restart server BTN [plotter] -->
          <button *ngIf="printingService === 'plotter'" class="d-flex align-items-center gap-1 px-2" mat-menu-item
            [class.zx-ltr]="!isRTL" (click)="restartServer()">
            <b class="zx-text-small m-0">
              {{'su-management.restart-server' | translate}}
            </b>
            <mat-icon class="mx-1 p-0 zx-pt-small">refresh</mat-icon>
          </button>
          <!-- git BTN [plotter + express] -->
          <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
            (click)="gitPull()">
            <b class="zx-text-small m-0">
              {{'su-management.git-pull' | translate}}
            </b>
            <mat-icon class="mx-1 p-0 zx-pt-small">sync</mat-icon>
          </button>
          <!-- show all screens BTN [plotter + express] -->
          <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
            (click)="onShowAllScreens()">
            <b class="zx-text-small m-0">
              {{'su-management.report.show-all-screens' | translate}}
            </b>
            <mat-icon class="mx-1 p-0 zx-pt-small">desktop_windows</mat-icon>
          </button>
          <!-- full inventory BTN [plotter + express] -->
          <button class="d-flex align-items-center gap-1 px-2" mat-menu-item [class.zx-ltr]="!isRTL"
            (click)="shoWallBranchesInventory()">
            <b class="zx-text-small m-0">
              {{'su-management.inventory-management.show-all-branches' | translate}}
            </b>
            <mat-icon class="mx-1 p-0 zx-pt-small">assignment</mat-icon>
          </button>


        </mat-menu>
        <!-- // ===== SU MANU [plotter + express] ===== -->

      </div>

    </div>

  </div>
  <!-- // printer -->

  <!-- orders -->
  <div *ngIf="subPage === 'orders'" class="d-flex flex-column">
    <mat-paginator class="m-0" [length]="totalOrders" [pageSize]="ordersPerPage" [pageSizeOptions]="pageSizeOptions"
      (page)="onChangedPageOrders($event)"></mat-paginator>
  </div>
  <!-- // orders -->

  <!-- users -->
  <div *ngIf="subPage === 'users'" class="d-flex flex-column">
    <mat-paginator class="m-0" [length]="totalUsers" [pageSize]="usersPerPage" [pageSizeOptions]="pageSizeOptions"
      (page)="onChangedPageUsers($event)"></mat-paginator>
  </div>
  <!-- // users -->

  <!-- inventory -->
  <div *ngIf="subPage === 'inventory'" class="d-flex w-100 px-3 py-2">
    <button mat-raised-button class="rounded-pill flex-grow-1" (click)="onSaveInventory()">
      {{ "my-profile.save-chainges" | translate }}
    </button>
  </div>
  <!-- // inventory -->

</div>
<!-- // --------------------------------- SUB SECTION -->